var amex = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1_1:1_",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 34 21.76"
	},
	children: [
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "0",
				width: "33.81",
				height: "21.76",
				rx: "2",
				ry: "2",
				fill: "#fff"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.16,19.38l-1.51-1.68-1.57,1.68h-9.69v-7.83h-3.08l3.83-8.76h3.71l1.33,3.02V2.78h4.64l.81,2.26,.81-2.26h3.54V1.45c0-.81-.64-1.45-1.45-1.45H1.45C.64,0,0,.64,0,1.45V20.31c0,.81,.64,1.45,1.45,1.45h31.1c.81,0,1.45-.64,1.45-1.45v-.93h-2.84Z",
				fill: "#0071ce"
			},
			children: [
			]
		},
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "31.56 18.45 34 18.45 30.81 15.03 34 11.66 31.62 11.66 29.59 13.87 27.62 11.66 25.18 11.66 28.43 15.09 25.18 18.45 27.56 18.45 29.59 16.25 31.56 18.45",
				fill: "#0071ce"
			},
			children: [
			]
		},
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "21.29 16.88 21.29 15.84 25.12 15.84 25.12 14.27 21.29 14.27 21.29 13.23 25.18 13.23 25.18 11.66 19.44 11.66 19.44 18.45 25.18 18.45 25.18 16.88 21.29 16.88",
				fill: "#0071ce"
			},
			children: [
			]
		},
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "32.2 10.68 33.94 10.68 33.94 3.83 31.16 3.89 29.65 8.12 28.08 3.89 25.18 3.89 25.18 10.68 27.04 10.68 27.04 5.92 28.78 10.68 30.4 10.68 32.2 5.92 32.2 10.68",
				fill: "#0071ce"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M22.22,3.89h-2.38l-3.02,6.79h2.03l.58-1.33h3.13l.58,1.33h2.09l-3.02-6.79Zm-2.15,3.89l.93-2.2,.93,2.2h-1.86Z",
				fill: "#0071ce"
			},
			children: [
			]
		},
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "32.32 14.85 34 16.71 34 13 32.32 14.85",
				fill: "#0071ce"
			},
			children: [
			]
		}
	]
};
var dinersClub = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 34.02 23.73"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.69,15.12c0-.65-.33-.6-.66-.61v-.19c.28,.01,.57,.01,.85,.01,.3,0,.71-.01,1.25-.01,1.86,0,2.87,1.25,2.87,2.52,0,.71-.41,2.51-2.96,2.51-.37,0-.7-.01-1.05-.01s-.65,0-.97,.01v-.19c.43-.04,.63-.06,.66-.55v-3.49h.01Zm.7,3.38c0,.56,.4,.62,.75,.62,1.56,0,2.06-1.17,2.06-2.24,0-1.35-.86-2.32-2.25-2.32-.29,0-.43,.02-.56,.03v3.91h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M5.25,19.15h.13c.2,0,.35,0,.35-.23v-1.95c0-.31-.11-.36-.38-.5v-.11c.33-.1,.75-.23,.77-.26,.06-.03,.09-.03,.13-.03s.04,.04,.04,.1v2.76c0,.23,.16,.23,.36,.23h.12v.19c-.25,0-.5-.01-.76-.01s-.51,0-.78,.01v-.19h.01Zm.77-4.22c-.19,0-.36-.18-.36-.36s.17-.35,.36-.35,.36,.16,.36,.35-.16,.36-.36,.36"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M7.48,17.01c0-.27-.08-.33-.41-.48v-.13c.31-.1,.6-.19,.95-.35,.02,0,.04,.01,.04,.07v.47c.41-.3,.77-.53,1.25-.53,.61,0,.82,.45,.82,1v1.86c0,.23,.16,.23,.36,.23h.13v.19c-.26,0-.5-.01-.76-.01s-.52,0-.78,.01v-.19h.13c.2,0,.35,0,.35-.23v-1.86c0-.41-.26-.61-.66-.61-.23,0-.6,.19-.84,.35v2.13c0,.23,.16,.23,.36,.23h.13v.19c-.26,0-.5-.01-.77-.01s-.51,0-.78,.01v-.19h.13c.2,0,.35,0,.35-.23v-1.9h-.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M11.15,17.36c-.01,.07-.01,.17,0,.41,.04,.68,.48,1.25,1.06,1.25,.4,0,.7-.21,.97-.48l.1,.1c-.33,.43-.74,.81-1.33,.81-1.15,0-1.37-1.1-1.37-1.57,0-1.41,.95-1.83,1.45-1.83,.58,0,1.21,.37,1.21,1.13v.13l-.07,.04h-2.03Zm1.27-.23c.18,0,.2-.09,.2-.18,0-.37-.22-.66-.62-.66-.43,0-.74,.32-.82,.85h1.25Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M13.41,19.15h.19c.2,0,.35,0,.35-.23v-2.02c0-.22-.27-.27-.38-.32v-.11c.52-.22,.81-.41,.88-.41,.04,0,.07,.02,.07,.09v.65h.01c.18-.28,.48-.74,.92-.74,.18,0,.41,.12,.41,.38,0,.19-.13,.37-.33,.37-.22,0-.22-.18-.48-.18-.12,0-.52,.17-.52,.6v1.69c0,.23,.14,.23,.35,.23h.4v.19c-.4,0-.7-.01-1-.01s-.6,0-.86,.01c0,0,0-.19,0-.19Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M16.19,18.34c.09,.48,.38,.88,.9,.88,.42,0,.58-.26,.58-.51,0-.85-1.57-.58-1.57-1.74,0-.4,.32-.92,1.11-.92,.23,0,.53,.07,.82,.21l.06,.74h-.17c-.07-.46-.32-.71-.78-.71-.29,0-.56,.17-.56,.48,0,.85,1.67,.58,1.67,1.72,0,.48-.38,.98-1.24,.98-.29,0-.62-.1-.88-.25l-.08-.82,.13-.03h-.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.74,15.62h-.18c-.13-.85-.74-1.18-1.54-1.18s-2.03,.56-2.03,2.28c0,1.46,1.04,2.5,2.14,2.5,.71,0,1.3-.49,1.45-1.25l.17,.04-.17,1.05c-.3,.19-1.11,.38-1.59,.38-1.68,0-2.75-1.08-2.75-2.71,0-1.47,1.31-2.53,2.73-2.53,.58,0,1.15,.19,1.69,.38l.07,1.02h.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25,19.15h.13c.2,0,.35,0,.35-.23v-4c0-.47-.11-.48-.38-.56v-.11c.29-.09,.59-.22,.75-.31,.08-.04,.13-.08,.16-.08,.04,0,.06,.04,.06,.1v4.97c0,.23,.16,.23,.36,.23h.12v.19c-.25,0-.5-.01-.76-.01s-.51,0-.78,.01v-.19h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.62,18.94c0,.13,.08,.13,.2,.13h.29v.16c-.31,.03-.9,.18-1.04,.22l-.03-.02v-.58c-.43,.36-.76,.6-1.27,.6-.39,0-.79-.26-.79-.86v-1.84c0-.19-.03-.37-.43-.4v-.13c.26,0,.84-.04,.92-.04,.08,0,.08,.04,.08,.21v1.86c0,.21,0,.84,.62,.84,.25,0,.57-.19,.87-.43v-1.94c0-.14-.35-.22-.6-.29v-.13c.65-.04,1.05-.1,1.13-.1,.06,0,.06,.04,.06,.13v2.62Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.05,16.57c.29-.25,.68-.51,1.07-.51,.84,0,1.34,.72,1.34,1.52,0,.95-.69,1.88-1.72,1.88-.53,0-.81-.17-1-.26l-.21,.17-.16-.08c.07-.42,.1-.85,.1-1.28v-3.1c0-.47-.11-.48-.38-.56v-.11c.29-.09,.59-.22,.75-.31,.08-.04,.13-.08,.16-.08,.04,0,.06,.04,.06,.1v2.63h0Zm0,1.95c0,.28,.26,.74,.75,.74,.77,0,1.09-.76,1.09-1.39,0-.78-.59-1.43-1.15-1.43-.27,0-.49,.18-.68,.33v1.75h-.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.02,23.52h.06c.14,0,.29-.02,.29-.22v-2.05c0-.2-.14-.22-.29-.22H.02v-.12c.16,0,.39,.01,.58,.01s.43-.01,.61-.01v.12h-.06c-.14,0-.29,.02-.29,.22v2.05c0,.2,.14,.22,.29,.22h.06v.12c-.19,0-.42-.01-.61-.01s-.42,.01-.58,.01c0,0,0-.12,0-.12Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.21,23.65c-.19,0-.42-.01-.61-.01s-.42,.01-.58,.01H0v-.16H.07c.14,0,.27-.01,.27-.21v-2.05c0-.19-.13-.2-.27-.21h-.07v-.16H.02c.16,0,.39,.01,.58,.01s.42-.01,.61-.01h.02v.16h-.07c-.14,0-.27,.01-.28,.21v2.05c0,.19,.13,.2,.28,.21h.07v.16s-.02,0-.02,0Zm-.02-.03v-.08h-.03c-.14,0-.31-.02-.31-.25v-2.05c0-.21,.17-.25,.31-.25h.03v-.08c-.18,0-.41,.01-.6,.01s-.41-.01-.56-.01v.08h.03c.14,0,.3,.02,.3,.25v2.05c0,.21-.17,.25-.3,.25H.03v.08c.16,0,.37-.01,.56-.01s.41,.01,.6,.01"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M3.9,22.87h0v-1.47c0-.32-.22-.37-.35-.37h-.09v-.12c.18,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01v.12h-.06c-.17,0-.35,.03-.35,.5v1.78c0,.13,0,.28,.02,.39h-.14l-2.02-2.25v1.62c0,.35,.07,.46,.37,.46h.07v.12c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01v-.12h.06c.27,0,.36-.18,.36-.5v-1.65c0-.22-.18-.36-.36-.36h-.06v-.12c.14,0,.3,.01,.45,.01,.12,0,.23-.01,.35-.01l1.74,1.96h.02Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M4.12,23.72h-.16l-1.98-2.22v1.57c0,.35,.06,.43,.36,.45h.09v.16h-.02c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01h-.02v-.16h.08c.26,0,.33-.17,.33-.48v-1.65c0-.21-.17-.33-.33-.33h-.07v-.16h.02c.14,0,.3,.01,.45,.01,.11,0,.23-.01,.36,0l1.72,1.94v-1.44c0-.31-.21-.35-.32-.36h-.1v-.16h.02c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01h.02v.16h-.08c-.17,0-.32,.02-.33,.48v1.78c0,.13,0,.27,.02,.39v.02h-.03Zm-.14-.04h.13c-.02-.12-.02-.25-.02-.38v-1.78c0-.47,.2-.51,.37-.51h.04v-.08c-.16,0-.31,.01-.47,.01-.18,0-.36-.01-.53-.01v.08h.07c.12,0,.36,.06,.36,.39v1.48h-.02l-1.74-1.96c-.11,0-.23,.01-.35,.01-.14,0-.29-.01-.43-.01v.08h.03c.18,0,.37,.14,.37,.37v1.65c0,.31-.09,.51-.37,.51h-.03v.08c.17,0,.35-.01,.51-.01s.32,.01,.49,.01v-.08h-.04c-.31,0-.39-.13-.39-.48v-1.66l2.03,2.27v.02Zm-.08-.81h0Zm0,0h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M5.09,21.1c-.29,0-.3,.07-.37,.36h-.12c.01-.11,.03-.22,.04-.33,.01-.11,.02-.22,.02-.33h.09c.03,.12,.13,.11,.23,.11h2.02c.1,0,.2,0,.21-.12h.09c-.01,.12-.03,.22-.04,.33v.31l-.12,.04c0-.14-.03-.38-.29-.38h-.65v2.08c0,.3,.13,.33,.32,.33h.08v.12c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01v-.12h.08c.21,0,.32-.02,.32-.32v-2.09h-.62Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M6.64,23.65c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01h-.01v-.16h.09c.21,0,.3,0,.31-.31v-2.07h-.62v-.02h.66s0,2.09,0,2.09c0,.31-.12,.35-.35,.35h-.06v.08c.16,0,.41-.01,.65-.01,.2,0,.47,.01,.62,.01v-.08h-.06c-.19,0-.35-.04-.35-.36v-2.09h.66c.27,0,.3,.22,.3,.37l.09-.03v-.31c.01-.1,.02-.2,.04-.3h-.06c-.02,.1-.13,.11-.22,.11h-2.04c-.09,0-.19,0-.22-.11h-.07c0,.11,0,.21-.02,.32-.01,.11-.03,.21-.04,.31h.08c.06-.27,.09-.36,.38-.36h0v.03c-.29,0-.28,.06-.35,.35h-.01s-.13,.01-.13,.01v-.02c.02-.11,.03-.22,.06-.33,.01-.11,.02-.21,.02-.33v-.02h.12c.02,.11,.1,.11,.2,.11h2.04c.11,0,.19,0,.19-.11v-.02h.02l.11,.02v.02c-.02,.1-.03,.21-.04,.31v.31h0v.02s-.14,.06-.14,.06v-.02c-.01-.14-.02-.36-.28-.36h-.62v2.06c0,.3,.12,.31,.31,.32h.09v.16h-.06Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M7.46,23.52h.06c.14,0,.29-.02,.29-.22v-2.05c0-.2-.14-.22-.29-.22h-.06v-.12c.23,0,.65,.01,.97,.01s.74-.01,1-.01v.6l-.12,.03c-.02-.26-.07-.46-.48-.46h-.55v1.02h.47c.23,0,.29-.13,.31-.35h.12c0,.16-.01,.3-.01,.46s0,.3,.01,.45l-.12,.02c-.02-.23-.03-.39-.3-.39h-.47v.91c0,.26,.22,.26,.48,.26,.47,0,.68-.03,.79-.48l.11,.02c-.06,.21-.1,.41-.13,.62-.25,0-.7-.01-1.06-.01s-.81,.01-1.04,.01v-.12h.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M9.56,23.65c-.26,0-.7-.01-1.06-.01s-.81,.01-1.04,.01h-.02v-.13h.02s.06-.01,.06-.01c.14,0,.27-.01,.27-.21v-2.05c0-.19-.13-.2-.27-.21h-.07v-.16h.02c.23,0,.65,.01,.97,.01s.74-.01,1-.01h.02v.22c0,.13,0,.28,.01,.39h0v.02s-.14,.03-.14,.03v-.02c-.02-.26-.06-.43-.46-.45h-.52v.99h.45c.22,0,.27-.12,.29-.32h.01s.13-.01,.13-.01v.02c0,.16-.01,.3-.01,.46s0,.3,.01,.45h0v.02s-.14,.02-.14,.02v-.02c-.03-.23-.03-.37-.29-.37h-.46v.89c0,.23,.2,.23,.46,.23,.47,0,.66-.02,.78-.47h.02s.12,.02,.12,.02h0c-.06,.22-.1,.43-.13,.63h-.01s-.02,.02-.02,.02Zm-.01-.03c.03-.2,.08-.39,.12-.59l-.08-.02c-.12,.43-.35,.48-.8,.48-.25,0-.49,0-.49-.27v-.92h.49c.28,0,.3,.17,.32,.39l.09-.02v-.88h-.09c-.02,.2-.09,.35-.32,.35h-.48v-1.06h.56c.41,0,.48,.21,.49,.46l.09-.02v-.57c-.27,0-.66,.01-.98,.01s-.71-.01-.96-.01v.08h.03c.14,0,.3,.02,.31,.25v2.05c0,.21-.17,.23-.31,.25h-.03v.08c.22,0,.68-.01,1.02-.01s.79,.01,1.04,.01"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M10.22,21.32c0-.29-.16-.3-.28-.3h-.07v-.12c.12,0,.37,.01,.61,.01s.42-.01,.63-.01c.49,0,.94,.13,.94,.69,0,.36-.23,.57-.55,.69l.67,1c.11,.17,.19,.21,.38,.23v.12c-.13,0-.26-.01-.38-.01s-.25,.01-.37,.01c-.3-.39-.56-.81-.81-1.27h-.26v.84c0,.3,.14,.31,.32,.31h.07v.12c-.22,0-.45-.01-.67-.01-.19,0-.37,.01-.57,.01v-.12h.07c.14,0,.28-.07,.28-.21v-1.98h-.02Zm.5,.91h.19c.39,0,.6-.14,.6-.61,0-.35-.22-.57-.57-.57-.12,0-.17,.01-.22,.01v1.17Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M12.54,23.65c-.13,0-.26-.01-.39-.01-.12,0-.25,.01-.38,0-.3-.39-.56-.81-.81-1.26h-.23v.82c0,.29,.12,.29,.3,.3h.09v.16h-.02c-.22,0-.46-.01-.67-.01-.19,0-.37,.01-.57,.01h-.01v-.16h.09c.14,0,.26-.07,.26-.19v-1.98c0-.28-.13-.28-.26-.28h-.09v-.16h.01c.12,0,.37,.01,.61,.01s.42-.01,.63-.01c.49,0,.95,.13,.95,.7,0,.36-.23,.58-.53,.7l.66,.98c.11,.17,.18,.2,.37,.22h.01v.16h-.01Zm-1.83-1.31h.27c.26,.46,.51,.88,.8,1.27,.12,0,.25-.01,.37-.01s.25,.01,.37,.01v-.09c-.19-.02-.27-.08-.38-.23l-.68-1.01h.02c.3-.13,.53-.33,.53-.68,0-.55-.42-.67-.91-.67-.21,0-.4,.01-.63,.01s-.47-.01-.59-.01v.08h.06c.12,0,.29,.02,.29,.31v1.98c0,.16-.14,.23-.29,.23h-.06v.08c.19,0,.37-.01,.55-.01,.22,0,.43,.01,.66,.01v-.08h-.06c-.18,0-.33-.02-.33-.33v-.86s.02,0,.02,0Zm0-.11h-.02v-1.2h.01s.11-.01,.22-.01c.36,0,.59,.23,.59,.59,0,.47-.22,.62-.62,.62h-.18Zm.19-.03c.39,0,.58-.13,.59-.59,0-.35-.21-.56-.56-.56-.1,0-.16,0-.2,.01v1.14h.17Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M15.21,22.87h0v-1.47c0-.32-.22-.37-.35-.37h-.09v-.12c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01v.12h-.06c-.17,0-.35,.03-.35,.5v1.78c0,.13,0,.28,.02,.39h-.14l-2.02-2.25v1.62c0,.35,.07,.46,.37,.46h.07v.12c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01v-.12h.06c.27,0,.36-.18,.36-.5v-1.65c0-.22-.18-.36-.36-.36h-.06v-.12c.14,0,.3,.01,.45,.01,.12,0,.23-.01,.35-.01l1.74,1.96h.02Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M15.43,23.72h-.16l-1.98-2.22v1.57c0,.35,.06,.43,.36,.45h.08v.16h-.02c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01h-.02v-.16h.07c.26,0,.33-.17,.33-.48v-1.65c0-.21-.17-.33-.33-.33h-.07v-.16h.02c.14,0,.3,.01,.45,.01,.11,0,.23-.01,.36,0l1.72,1.94v-1.44c0-.31-.21-.35-.32-.36h-.1v-.16h.02c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01h.02v.16h-.08c-.16,0-.32,.02-.33,.48v1.78c0,.13,0,.27,.02,.39v.02h-.01Zm-.14-.04h.12c-.01-.12-.02-.25-.02-.38v-1.78c0-.47,.2-.51,.37-.51h.04v-.08c-.16,0-.31,.01-.47,.01-.18,0-.36-.01-.53-.01v.08h.07c.12,0,.36,.06,.36,.39v1.48h-.02l-1.74-1.96c-.11,0-.23,.01-.35,.01-.14,0-.29-.01-.43-.01v.08h.03c.19,0,.37,.14,.37,.37v1.65c0,.31-.09,.51-.37,.51h-.03v.08c.17,0,.35-.01,.51-.01s.32,.01,.49,.01v-.08h-.04c-.31,0-.39-.13-.39-.48v-1.66l2.04,2.27v.02Zm-.08-.81h0Zm0,0h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M16.44,23.08c-.04,.13-.09,.23-.09,.3,0,.12,.17,.13,.29,.13h.04v.12c-.16,0-.31-.01-.48-.01-.14,0-.28,0-.42,.01v-.12h.02c.16,0,.28-.09,.33-.26l.62-1.79c.06-.14,.12-.35,.14-.49,.12-.04,.28-.12,.36-.17h.03s.02,0,.02,.01c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.11,.13,.16,.26,.16h.02v.12c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01v-.12h.04c.09,0,.25-.01,.25-.11,0-.06-.03-.16-.08-.28l-.16-.46h-.89l-.12,.41h.02Zm.57-1.75h0l-.37,1.1h.74l-.36-1.1h-.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M18.53,23.65c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01h-.02v-.16h.06c.09,0,.22-.02,.22-.1,0-.04-.03-.16-.08-.28l-.14-.45h-.87l-.12,.39c-.04,.13-.09,.23-.09,.3,0,.1,.14,.12,.28,.12h.06v.16h-.02c-.16,0-.31-.02-.47-.02-.14,0-.28,0-.42,.01h-.02v-.16h.04c.14,0,.27-.08,.32-.25l.62-1.79c.06-.14,.12-.35,.16-.5,.12-.04,.28-.12,.36-.17h.03s.03,0,.04,.02c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.1,.12,.14,.25,.14h.04v.16h0Zm-1.11-.02c.19,0,.38-.01,.57-.01s.36,0,.52,.01v-.08h0c-.13,0-.22-.06-.28-.17-.06-.12-.1-.27-.14-.4l-.72-2.05s-.02-.07-.03-.09h-.02c-.08,.04-.23,.12-.35,.16-.02,.14-.09,.35-.14,.49l-.62,1.79c-.06,.17-.2,.27-.36,.27h0v.08c.13,0,.27-.01,.4-.01,.16,0,.3,0,.46,.01v-.08h-.02c-.12,0-.3-.01-.31-.16,0-.08,.04-.18,.09-.31h0l.13-.42h.91l.16,.47c.04,.12,.08,.23,.08,.29,0,.12-.17,.13-.26,.13h-.02v.08h-.03Zm-.8-1.15l.38-1.15h.02v.02h0v-.02h.01l.37,1.15h-.78Zm.04-.03h.69l-.35-1.05s-.35,1.05-.35,1.05Zm.33-1.08h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M18.7,21.1c-.29,0-.3,.07-.37,.36h-.12c.01-.11,.03-.22,.04-.33,.01-.11,.02-.22,.02-.33h.09c.03,.12,.13,.11,.23,.11h2.02c.1,0,.2,0,.21-.12h.09c-.01,.12-.03,.22-.04,.33v.31l-.11,.04c0-.14-.02-.38-.29-.38h-.65v2.08c0,.3,.13,.33,.32,.33h.08v.12c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01v-.12h.08c.21,0,.32-.02,.32-.32v-2.09h-.63Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M20.24,23.65c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01h-.01v-.16h.09c.21,0,.3,0,.31-.31v-2.07h-.62v-.02h.66s0,2.09,0,2.09c0,.31-.12,.35-.35,.35h-.06v.08c.16,0,.41-.01,.65-.01,.2,0,.47,.01,.62,.01v-.08h-.06c-.19,0-.35-.04-.35-.36v-2.09h.66c.27,0,.3,.22,.3,.37l.09-.03v-.31c0-.1,.02-.2,.04-.3h-.06c-.02,.1-.13,.11-.22,.11h-2.04c-.09,0-.19,0-.22-.11h-.07c0,.11,0,.21-.02,.32,0,.11-.03,.21-.04,.31h.09c.06-.27,.09-.36,.38-.36h0v.03c-.29,0-.28,.06-.35,.35h-.01s-.13,.01-.13,.01v-.02c.02-.11,.03-.22,.04-.33,.01-.11,.02-.22,.02-.33v-.02h.12c.02,.11,.1,.11,.2,.11h2.04c.11,0,.19,0,.19-.11v-.02h.02l.11,.02v.02c-.02,.1-.03,.21-.04,.31v.31h0v.02s-.14,.06-.14,.06v-.02c0-.14-.02-.36-.28-.36h-.62v2.06c0,.3,.12,.31,.31,.32h.09v.16h-.06Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.09,23.52h.06c.14,0,.29-.02,.29-.22v-2.05c0-.2-.14-.22-.29-.22h-.06v-.12c.16,0,.39,.01,.58,.01s.43-.01,.61-.01v.12h-.06c-.14,0-.29,.02-.29,.22v2.05c0,.2,.14,.22,.29,.22h.06v.12c-.19,0-.42-.01-.62-.01s-.42,.01-.58,.01v-.12h.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.28,23.65c-.19,0-.42-.01-.62-.01s-.42,.01-.58,.01h-.01v-.13h.01s.06-.01,.06-.01c.14,0,.27-.01,.27-.21v-2.05c0-.19-.13-.2-.27-.21h-.07v-.16h.01c.16,0,.39,.01,.58,.01s.43-.01,.61-.01h.01v.16h-.07c-.14,0-.27,.01-.28,.21v2.05c0,.19,.13,.2,.28,.21h.07v.16h0Zm-.02-.04v-.08h-.03c-.14,0-.31-.02-.31-.25v-2.05c0-.21,.17-.25,.31-.25h.03v-.08c-.18,0-.4,.01-.6,.01s-.41-.01-.56-.01v.08h.03c.13,0,.31,.02,.31,.25v2.05c0,.21-.17,.25-.31,.25h-.03v.08c.16,0,.37-.01,.56-.01s.41,.01,.6,.01"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M23.84,20.84c.84,0,1.5,.51,1.5,1.35,0,.9-.65,1.5-1.48,1.5s-1.46-.57-1.46-1.4,.63-1.45,1.45-1.45m.06,2.67c.76,0,.89-.67,.89-1.24s-.31-1.27-.96-1.27c-.68,0-.89,.61-.89,1.14,0,.7,.32,1.37,.96,1.37"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.38,22.29c0-.82,.63-1.46,1.46-1.46v.03c-.8,0-1.43,.62-1.43,1.43s.62,1.39,1.45,1.39,1.46-.59,1.46-1.48c0-.82-.66-1.34-1.48-1.34v-.03c.84,0,1.52,.52,1.52,1.37,0,.91-.66,1.52-1.49,1.52s-1.48-.57-1.48-1.43m.55-.13c0-.52,.21-1.15,.9-1.15s.98,.7,.98,1.28-.13,1.26-.91,1.26h0v-.03c.75,0,.87-.66,.88-1.23,0-.57-.3-1.25-.95-1.25s-.87,.6-.87,1.11c0,.7,.32,1.35,.94,1.36v.02h0c-.65,.01-.97-.67-.97-1.37"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.98,22.87h0v-1.47c0-.32-.22-.37-.35-.37h-.09v-.12c.18,0,.37,.01,.55,.01,.17,0,.32-.01,.48-.01v.12h-.06c-.17,0-.35,.03-.35,.5v1.78c0,.13,0,.28,.02,.39h-.14l-2.02-2.25v1.62c0,.35,.07,.46,.37,.46h.07v.12c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01v-.12h.06c.27,0,.36-.18,.36-.5v-1.65c0-.22-.18-.36-.36-.36h-.06v-.12c.14,0,.3,.01,.45,.01,.12,0,.23-.01,.35-.01l1.74,1.96h.02Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.21,23.72h-.17l-1.98-2.22v1.57c0,.35,.06,.43,.35,.45h.09v.16h-.02c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01h-.01v-.16h.07c.26,0,.33-.17,.33-.48v-1.65c0-.21-.17-.33-.33-.33h-.07v-.16h.01c.14,0,.3,.01,.45,.01,.11,0,.23-.01,.36,0l1.72,1.94v-1.44c0-.31-.21-.35-.32-.36h-.1v-.16h.02c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01h.02v.16h-.08c-.16,0-.32,.02-.33,.48v1.78c0,.13,0,.27,.02,.39v.02h0Zm-.14-.04h.13c-.02-.12-.02-.25-.02-.38v-1.78c0-.47,.2-.51,.37-.51h.04v-.08c-.16,0-.31,.01-.47,.01-.18,0-.36-.01-.53-.01v.08h.07c.12,0,.36,.06,.36,.39v1.48h-.02l-1.74-1.96c-.11,0-.23,.01-.35,.01-.14,0-.29-.01-.43-.01v.08h.03c.19,0,.38,.14,.38,.37v1.65c0,.31-.09,.51-.37,.51h-.03v.08c.17,0,.35-.01,.51-.01s.32,.01,.49,.01v-.08h-.06c-.31,0-.38-.13-.38-.48v-1.66l2.03,2.27v.02Zm-.09-.81h0Zm0,0h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.22,23.08c-.03,.13-.09,.23-.09,.3,0,.12,.17,.13,.29,.13h.04v.12c-.16,0-.31-.01-.48-.01-.14,0-.28,0-.42,.01v-.12h.02c.16,0,.28-.09,.35-.26l.62-1.79c.06-.14,.12-.35,.14-.49,.12-.04,.28-.12,.36-.17h.03s.02,0,.02,.01c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.11,.13,.16,.26,.16h.02v.12c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01v-.12h.04c.09,0,.25-.01,.25-.11,0-.06-.03-.16-.08-.28l-.16-.46h-.89l-.12,.41h.01Zm.57-1.75h0l-.37,1.1h.74l-.36-1.1h-.01Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.3,23.65c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01h-.02v-.16h.06c.09,0,.22-.02,.22-.1,0-.04-.03-.16-.08-.28l-.14-.45h-.87l-.12,.39c-.04,.13-.09,.23-.09,.3,0,.1,.14,.12,.28,.12h.06v.16h-.02c-.16,0-.31-.02-.47-.02-.14,0-.28,0-.42,.01h-.02v-.16h.04c.14,0,.27-.09,.32-.25l.62-1.79c.04-.14,.12-.35,.16-.5,.12-.04,.28-.12,.36-.17h.03s.03,0,.04,.02c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.1,.11,.14,.25,.14h.04v.16h0Zm-1.11-.02c.19,0,.38-.01,.57-.01s.36,0,.52,.01v-.08h0c-.13,0-.22-.06-.28-.17-.06-.12-.1-.27-.14-.4l-.72-2.05s-.02-.07-.03-.09t0,0h-.02c-.08,.04-.23,.12-.35,.16-.02,.14-.09,.35-.14,.49l-.62,1.79c-.06,.17-.2,.27-.36,.27h0v.08c.13,0,.27-.01,.41-.01,.16,0,.3,0,.46,.01v-.08h-.02c-.12,0-.3-.01-.31-.16,0-.08,.04-.18,.09-.31h0l.13-.42h.91l.16,.47c.04,.12,.08,.23,.08,.29,0,.12-.17,.13-.26,.13h-.02v.08h-.04Zm-.8-1.15l.38-1.14h.02v.02h0v-.02h.01l.37,1.14h-.78Zm.04-.03h.69l-.35-1.05s-.35,1.05-.35,1.05Zm.33-1.08h0Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.3,23.26c0,.16,.11,.2,.23,.22,.16,.01,.33,.01,.51,0,.17-.02,.3-.11,.38-.21,.07-.09,.1-.2,.12-.28h.11c-.04,.22-.1,.45-.14,.67-.35,0-.69-.01-1.04-.01s-.69,.01-1.04,.01v-.12h.06c.14,0,.29-.02,.29-.27v-2.02c0-.2-.16-.22-.29-.22h-.06v-.12c.21,0,.41,.01,.61,.01s.4-.01,.59-.01v.12h-.1c-.14,0-.27,0-.27,.21v2.02h.02Z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M33.51,23.65c-.35,0-.69-.01-1.04-.01s-.69,.01-1.04,.01h-.01v-.16h.07c.14,0,.28-.01,.28-.25v-2.02c0-.19-.13-.2-.28-.21h-.07v-.16h.01c.21,0,.41,.01,.62,.01s.39-.01,.59-.01h.01v.16h-.11c-.16,0-.25,0-.25,.2v2.02c0,.14,.1,.19,.22,.2h.21c.1,0,.19,0,.3-.01,.16-.02,.3-.11,.37-.2,.06-.09,.09-.19,.12-.28h.01s.13-.01,.13-.01v.02c-.04,.22-.1,.45-.14,.67h-.01s-.01,.02-.01,.02Zm-.01-.03c.04-.21,.1-.42,.13-.63h-.08c-.02,.09-.06,.19-.12,.28-.08,.1-.22,.2-.39,.22-.1,.01-.2,.01-.3,.01h-.22c-.12-.01-.25-.07-.25-.23v-2.02c0-.22,.13-.23,.28-.23h.08v-.08c-.19,0-.38,.01-.58,.01s-.4-.01-.6-.01v.08h.03c.14,0,.31,.02,.31,.25v2.02c0,.26-.17,.28-.31,.28h-.03v.08c.33,0,.68-.01,1.01-.01s.68,.01,1.01,.01"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M33.61,20.8c.23,0,.41,.18,.41,.41s-.18,.41-.41,.41-.41-.18-.41-.41,.18-.41,.41-.41m0,.75c.19,0,.32-.16,.32-.33s-.13-.33-.32-.33-.32,.16-.32,.33,.14,.33,.32,.33m-.2-.11v-.02s.06,0,.06-.03v-.3s0-.06-.06-.06v-.02h.21c.07,0,.13,.03,.13,.11,0,.07-.04,.11-.1,.12l.07,.1s.07,.08,.09,.1h-.08s-.07-.07-.14-.18h-.04v.13s0,.02,.06,.03v.02h-.19Zm.14-.23h.04s.08-.04,.08-.1-.04-.09-.08-.09h-.04v.19Z"
					},
					children: [
					]
				}
			]
		},
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M9.17,6.98C9.17,3.32,12.14,.36,15.8,.36s6.63,2.96,6.63,6.63-2.96,6.63-6.63,6.63-6.63-2.96-6.63-6.63",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M15.81,13.74c-3.8,.02-6.93-3.06-6.93-6.81C8.88,2.83,12.01,0,15.81,0h1.78c3.75,0,7.19,2.83,7.19,6.93,0,3.74-3.43,6.81-7.19,6.81h-1.78Zm.01-13.17c-3.48,0-6.28,2.82-6.28,6.28s2.82,6.28,6.28,6.28,6.28-2.82,6.28-6.28S19.28,.57,15.82,.57m-1.43,10V3.14c-1.49,.58-2.55,2.02-2.56,3.72,0,1.69,1.06,3.14,2.56,3.72m5.41-3.72c0-1.69-1.07-3.14-2.56-3.72v7.44c1.49-.58,2.55-2.02,2.56-3.72",
						fill: "#0069aa"
					},
					children: [
					]
				}
			]
		}
	]
};
var discover = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		viewBox: "0 0 34 21.74"
	},
	children: [
		{
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "linearGradient",
					type: "element",
					value: "",
					attributes: {
						id: "linear-gradient",
						x1: "-.05",
						y1: "-.1",
						x2: ".95",
						y2: "-.1",
						gradientTransform: "translate(17.72 12.83) rotate(-122.57) scale(3.15 -3.15)",
						gradientUnits: "userSpaceOnUse"
					},
					children: [
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: "0",
								"stop-color": "#ff9200"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".21",
								"stop-color": "#ff8d00"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".45",
								"stop-color": "#ff7f00"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".62",
								"stop-color": "#ff7100"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".83",
								"stop-color": "#ff5d00"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: "1",
								"stop-color": "#ff5200"
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			name: "image",
			type: "element",
			value: "",
			attributes: {
				width: "35",
				height: "20",
				transform: "translate(14.54 10.98) scale(.14 -.14)",
				"xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAOCAYAAAChHnWMAAAACXBIWXMAAE9aAABPWgHOoUeGAAAAzUlEQVQ4jcWUCwrEIBBDx8+d9rB713Fp0RJjdFu6bIUwxU/zyIihvKwYjlDVRhB1U4Q6U7J5rWvhbSHvCGhaqppZjzju2aqDWSFF07WdMbPcmTAMzq9gIn2jkoDw3fn4Zx4MEUbNKxiHNaVIEAjWJaEMzsIUukszGE4kYRJodBeG24P950RcJfErGCco1aqI7VBJYMQz0xVMO+uUjNOFvZTEXZhWuU2nkljBnIVkGAY5klDvwzeYq4mV+b7+nfgHDF7aoR1PwKiH75FhZh/9cY0ue4uTswAAAABJRU5ErkJggg=="
			},
			children: [
			]
		},
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.12,.37c-.1,0-.2,.02-.29,.06-.25,.11-.42,.35-.44,.63,0,.02-.01,.04-.01,.06V20.62c0,.08,.02,.14,.04,.21,.03,.11,.08,.2,.16,.29,.07,.08,.16,.15,.26,.19,.01,0,.03,0,.05,0,.08,.03,.16,.05,.24,.05H21.83c.14,0,.28-.02,.42-.02,.24,0,.49-.02,.73-.04,.3-.03,.59-.08,.88-.13,.4-.08,.79-.18,1.17-.3,1.43-.46,2.71-1.22,3.8-2.2,.31-.28,.6-.57,.87-.88,.2-.22,.38-.46,.56-.7,.15-.2,.29-.41,.43-.62,.12-.19,.24-.38,.35-.58,.09-.17,.17-.35,.25-.52,.08-.17,.16-.34,.24-.51,.06-.16,.12-.32,.17-.48,.06-.16,.12-.31,.16-.47,.04-.14,.08-.29,.11-.44,.04-.15,.08-.29,.11-.44,.03-.14,.05-.28,.07-.41,.02-.14,.05-.27,.06-.41,.02-.13,.04-.27,.05-.4,.01-.13,.01-.26,.02-.39s.02-.26,.02-.39c0-.06,0-.11,0-.17,0-.07,0-.14-.01-.21,0-.12-.01-.24-.02-.36s0-.24-.02-.36c-.01-.12-.03-.23-.04-.35-.01-.12-.03-.23-.05-.34-.02-.11-.03-.23-.05-.34-.02-.11-.05-.22-.07-.33-.02-.11-.06-.22-.08-.33-.03-.11-.05-.22-.08-.33-.03-.11-.06-.21-.1-.32-.03-.1-.08-.21-.11-.31-.04-.1-.07-.21-.11-.31-.04-.1-.08-.2-.12-.3-.04-.1-.09-.2-.14-.29-.05-.1-.09-.2-.14-.29-.05-.1-.1-.19-.15-.29-.05-.09-.11-.18-.17-.28s-.11-.19-.17-.28c-.06-.09-.11-.19-.17-.28-.06-.09-.13-.17-.2-.26-.06-.09-.13-.18-.2-.26-.07-.09-.13-.18-.2-.26-.07-.09-.15-.16-.22-.25s-.15-.17-.22-.25c-.08-.08-.15-.17-.22-.25-.08-.08-.17-.15-.25-.23-.08-.08-.17-.15-.25-.23-.09-.08-.17-.16-.25-.23-.09-.07-.19-.14-.28-.21-.09-.07-.19-.14-.28-.21-.1-.07-.19-.14-.29-.21-.1-.07-.21-.13-.32-.19-.11-.06-.21-.13-.32-.19-.11-.06-.22-.12-.33-.18-.12-.06-.24-.11-.35-.17s-.23-.12-.35-.17c-.13-.05-.26-.1-.39-.15-.35-.13-.71-.25-1.08-.34-.41-.11-.83-.19-1.25-.25-.46-.06-.93-.1-1.4-.1H1.12Zm15.7,12.89c-1.35,0-2.45-1.1-2.45-2.45s1.1-2.45,2.45-2.45,2.45,1.1,2.45,2.45-1.1,2.45-2.45,2.45Zm14.1-4.43c0,.2-.16,.36-.35,.36s-.35-.16-.35-.36,.16-.36,.35-.36,.35,.16,.35,.36Zm-2.57-.32c1.04,0,1.64,.5,1.64,1.36,0,.71-.37,1.17-1.05,1.31l1.45,1.95h-1.11l-1.25-1.86h-.12v1.86h-.9v-4.62h1.34Zm-1.93,0v.78h-1.66v1.03h1.59v.78h-1.59v1.25h1.66v.78h-2.56v-4.62h2.56Zm-6.42,0l1.23,3.1,1.25-3.1h.98l-2,4.74h-.49l-1.96-4.74h.98Zm-7.02-.1c.39,0,.71,.08,1.11,.28v1.06c-.37-.37-.7-.52-1.13-.52-.85,0-1.51,.7-1.51,1.59,0,.94,.64,1.59,1.55,1.59,.41,0,.73-.15,1.09-.51v1.06c-.41,.19-.74,.27-1.13,.27-1.37,0-2.44-1.05-2.44-2.41s1.09-2.42,2.46-2.42Zm-2.9,.54l-.47,.62c-.23-.26-.46-.37-.73-.37-.39,0-.67,.22-.67,.51,0,.25,.16,.38,.7,.58,1.03,.38,1.33,.71,1.33,1.44,0,.89-.66,1.52-1.59,1.52-.69,0-1.18-.27-1.6-.88l.58-.56c.21,.4,.55,.62,.98,.62,.4,0,.7-.28,.7-.65,0-.19-.09-.36-.27-.48-.09-.06-.27-.14-.62-.26-.85-.3-1.14-.63-1.14-1.27,0-.76,.62-1.32,1.44-1.32,.51,0,.97,.17,1.36,.51Zm-3.37-.44v4.62h-.9v-4.62h.9Zm-3.8,0c1.46,0,2.48,.95,2.48,2.31,0,.68-.31,1.34-.84,1.77-.44,.37-.95,.53-1.65,.53H1.57v-4.62h1.32Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.91,9.24v1.4h.26c.58,0,.88-.25,.88-.71s-.31-.68-.87-.68h-.28Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M2.47,12.35h.24c.58,0,.95-.11,1.23-.37,.31-.28,.5-.72,.5-1.16s-.19-.87-.5-1.15c-.3-.27-.65-.37-1.23-.37h-.24v3.06Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "30.51 8.81 30.53 8.81 30.6 8.76 30.53 8.7 30.51 8.7 30.51 8.81",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.28,8.83c0,.16,.13,.29,.28,.29s.28-.13,.28-.29-.13-.29-.28-.29-.28,.13-.28,.29Zm.42-.08l-.09,.11,.13,.17h-.12l-.11-.16v.16h-.1v-.41h.13c.1,0,.15,.04,.15,.13Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.57,13.13h1.32c.7,0,1.21-.16,1.65-.53,.53-.44,.84-1.09,.84-1.77,0-1.36-1.02-2.31-2.48-2.31H1.57v4.62Zm2.38-3.46c.31,.28,.5,.71,.5,1.15s-.19,.89-.5,1.16c-.28,.26-.65,.37-1.23,.37h-.24v-3.06h.24c.58,0,.94,.1,1.23,.37Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						x: "5.79",
						y: "8.51",
						width: ".9",
						height: "4.62",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M7.27,9.76c0,.64,.29,.96,1.14,1.27,.35,.12,.53,.21,.62,.26,.18,.12,.27,.28,.27,.48,0,.37-.3,.65-.7,.65-.43,0-.78-.21-.98-.62l-.58,.56c.42,.61,.91,.88,1.6,.88,.94,0,1.59-.62,1.59-1.52,0-.73-.3-1.07-1.33-1.44-.54-.2-.7-.33-.7-.58,0-.29,.28-.51,.67-.51,.27,0,.49,.11,.73,.37l.47-.62c-.39-.34-.85-.51-1.36-.51-.82,0-1.44,.57-1.44,1.32Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M10.51,10.83c0,1.36,1.07,2.41,2.44,2.41,.39,0,.72-.08,1.13-.27v-1.06c-.36,.36-.68,.51-1.09,.51-.91,0-1.55-.66-1.55-1.59,0-.89,.66-1.59,1.51-1.59,.43,0,.76,.15,1.13,.52v-1.06c-.4-.2-.72-.28-1.11-.28-1.37,0-2.46,1.07-2.46,2.42Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "19.01 8.51 20.97 13.25 21.45 13.25 23.45 8.51 22.47 8.51 21.23 11.62 19.99 8.51 19.01 8.51",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "23.86 13.13 26.41 13.13 26.41 12.35 24.76 12.35 24.76 11.1 26.35 11.1 26.35 10.32 24.76 10.32 24.76 9.3 26.41 9.3 26.41 8.51 23.86 8.51 23.86 13.13",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.01,13.13h.9v-1.86h.12l1.25,1.86h1.11l-1.45-1.95c.68-.14,1.05-.6,1.05-1.31,0-.86-.6-1.36-1.64-1.36h-1.34v4.62Zm2.04-3.21c0,.46-.31,.71-.88,.71h-.26v-1.4h.28c.56,0,.87,.24,.87,.68Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.42,8.63v.41h.1v-.16l.11,.16h.12l-.13-.17,.09-.11c0-.08-.06-.13-.15-.13h-.13Zm.11,.07l.07,.05-.07,.05h-.02v-.11h.02Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.21,8.83c0,.2,.16,.36,.35,.36s.35-.16,.35-.36-.16-.36-.35-.36-.35,.16-.35,.36Zm.63,0c0,.16-.13,.29-.28,.29s-.28-.13-.28-.29,.13-.29,.28-.29,.28,.13,.28,.29Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M19.26,10.82c0-1.35-1.1-2.45-2.45-2.45s-2.45,1.1-2.45,2.45,1.1,2.45,2.45,2.45,2.45-1.1,2.45-2.45Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M19.26,10.82c0-1.35-1.1-2.45-2.45-2.45s-2.45,1.1-2.45,2.45,1.1,2.45,2.45,2.45,2.45-1.1,2.45-2.45Z",
						fill: "url(#linear-gradient)"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.83,.43c.09-.04,.19-.06,.29-.06h.46l.65-.37H1.12C.5,0,0,.5,0,1.12v.16l.38-.22c.02-.28,.19-.52,.44-.63Z",
						fill: "#e15115"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.37,1.12s.01-.04,.01-.06l-.38,.22v.97l.37-.22v-.92Z",
						fill: "#e25215"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "3.26 .37 3.9 0 2.22 0 1.58 .37 3.26 .37",
						fill: "#e25215"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "3.26 .37 4.94 .37 5.58 0 3.9 0 3.26 .37",
						fill: "#e25316"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 2.04 0 2.25 0 3.22 .37 3.01 .37 2.04",
						fill: "#e25316"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "6.62 .37 7.26 0 5.58 0 4.94 .37 6.62 .37",
						fill: "#e35416"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 3.01 0 3.22 0 4.19 .37 3.98 .37 3.01",
						fill: "#e35416"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "8.3 .37 8.94 0 7.26 0 6.62 .37 8.3 .37",
						fill: "#e35516"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 3.98 0 4.19 0 5.16 .37 4.95 .37 3.98",
						fill: "#e35516"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "9.98 .37 10.62 0 8.94 0 8.3 .37 9.98 .37",
						fill: "#e35616"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 4.95 0 5.16 0 6.13 .37 5.92 .37 4.95",
						fill: "#e35616"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 5.92 0 6.13 0 7.1 .37 6.89 .37 5.92",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "11.65 .37 12.3 0 10.62 0 9.98 .37 11.65 .37",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 6.89 0 7.1 0 8.07 .37 7.86 .37 6.89",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "13.33 .37 13.98 0 12.3 0 11.65 .37 13.33 .37",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "15.01 .37 15.66 0 13.98 0 13.33 .37 15.01 .37",
						fill: "#e55816"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 7.86 0 8.07 0 9.04 .37 8.83 .37 7.86",
						fill: "#e55816"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "16.69 .37 17.34 0 15.66 0 15.01 .37 16.69 .37",
						fill: "#e55916"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 8.83 0 9.04 0 10.01 .37 9.8 .37 8.83",
						fill: "#e55916"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 9.8 0 10.01 0 10.98 .37 10.77 .37 9.8",
						fill: "#e55a16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "18.37 .37 19.02 0 17.34 0 16.69 .37 18.37 .37",
						fill: "#e55a16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 10.77 0 10.98 0 11.95 .37 11.73 .37 10.77",
						fill: "#e65b16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "20.05 .37 20.7 0 19.02 0 18.37 .37 20.05 .37",
						fill: "#e65b16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 11.73 0 11.95 0 12.92 .37 12.7 .37 11.73",
						fill: "#e65c17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "21.73 .37 22.38 0 20.7 0 20.05 .37 21.73 .37",
						fill: "#e65c17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.83,.37c.48,0,.94,.04,1.4,.1l.83-.48h-1.68l-.65,.37h.1Z",
						fill: "#e75d17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 12.7 0 12.92 0 13.89 .37 13.67 .37 12.7",
						fill: "#e75d17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.48,.72l1.26-.72h-1.68l-.83,.48c.43,.06,.84,.14,1.25,.25Z",
						fill: "#e75e17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 13.67 0 13.89 0 14.86 .37 14.64 .37 13.67",
						fill: "#e75e17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.56,1.07l1.85-1.07h-1.68l-1.26,.72c.37,.1,.73,.21,1.08,.34Z",
						fill: "#e85f17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 14.64 0 14.86 0 15.83 .37 15.61 .37 14.64",
						fill: "#e85f17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.96,1.22l2.11-1.22h-.65l-1.85,1.07c.13,.05,.26,.09,.39,.15Z",
						fill: "#e86017"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 15.61 0 15.83 0 16.2 .37 15.99 .37 15.61",
						fill: "#e86017"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M26.31,1.39l2.41-1.39h-.65l-2.11,1.22c.12,.05,.24,.11,.35,.17Z",
						fill: "#e86117"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 15.99 0 16.2 0 16.58 .37 16.36 .37 15.99",
						fill: "#e86117"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 16.36 0 16.58 0 16.95 .37 16.74 .37 16.36",
						fill: "#e96217"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M26.66,1.56l2.7-1.56h-.65l-2.41,1.39c.12,.06,.24,.11,.35,.17Z",
						fill: "#e96217"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27,1.74l3.02-1.74h-.65l-2.7,1.56c.11,.06,.22,.12,.33,.18Z",
						fill: "#e96317"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 16.74 0 16.95 0 17.33 .37 17.11 .37 16.74",
						fill: "#e96317"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.31,1.93l3.35-1.93h-.65l-3.02,1.74c.11,.06,.21,.13,.32,.19Z",
						fill: "#e96418"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 17.11 0 17.33 0 17.7 .37 17.49 .37 17.11",
						fill: "#e96418"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.63,2.13l3.68-2.13h-.65l-3.35,1.93c.11,.06,.21,.12,.32,.19Z",
						fill: "#e96518"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 17.49 0 17.7 0 18.08 .37 17.86 .37 17.49",
						fill: "#e96518"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.92,2.33L31.96,0h-.65l-3.68,2.13c.1,.07,.19,.14,.29,.21Z",
						fill: "#ea6618"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 17.86 0 18.08 0 18.45 .37 18.24 .37 17.86",
						fill: "#ea6618"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.2,2.54l4.41-2.54h-.65l-4.04,2.33c.1,.07,.19,.14,.28,.21Z",
						fill: "#ea6718"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 18.24 0 18.45 0 18.83 .37 18.61 .37 18.24",
						fill: "#ea6718"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.49,2.76L33.16,.06c-.09-.02-.18-.06-.28-.06h-.27l-4.41,2.54c.09,.07,.19,.14,.28,.21Z",
						fill: "#ea6818"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 18.61 0 18.83 0 19.2 .37 18.99 .37 18.61",
						fill: "#ea6818"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 18.99 0 19.2 0 19.58 .37 19.36 .37 18.99",
						fill: "#ea6918"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.74,2.98L33.52,.23c-.11-.08-.23-.13-.36-.17l-4.67,2.7c.09,.07,.17,.15,.25,.23Z",
						fill: "#ea6918"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 19.36 0 19.58 0 19.95 .37 19.74 .37 19.36",
						fill: "#eb6a18"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.99,3.21L33.76,.46c-.07-.09-.15-.17-.24-.24l-4.78,2.76c.09,.07,.17,.15,.25,.23Z",
						fill: "#eb6a18"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 19.74 0 19.95 0 20.33 .37 20.11 .37 19.74",
						fill: "#eb6b19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.25,3.44l4.68-2.7c-.04-.1-.1-.19-.16-.28l-4.77,2.75c.08,.08,.17,.15,.25,.23Z",
						fill: "#eb6b19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.47,3.69l4.52-2.61c0-.12-.03-.23-.07-.34l-4.68,2.7c.08,.08,.15,.16,.22,.25Z",
						fill: "#eb6c19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.37,20.11l-.37,.22v.3s.01,.05,.01,.07l.36-.21v-.37Z",
						fill: "#eb6c19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.37,20.62v-.14l-.36,.21c0,.12,.03,.23,.07,.34l.33-.19c-.02-.07-.04-.14-.04-.21Z",
						fill: "#eb6d19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.69,3.93l4.31-2.49v-.33s0-.03,0-.04l-4.52,2.61c.08,.08,.15,.16,.22,.25Z",
						fill: "#eb6d19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.92,4.18l4.08-2.36v-.37l-4.31,2.49c.07,.08,.15,.16,.22,.25Z",
						fill: "#ec6e19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.42,20.84l-.33,.19c.04,.1,.1,.19,.17,.28l.32-.18c-.07-.08-.12-.18-.16-.29Z",
						fill: "#ec6e19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.11,4.44l3.89-2.24v-.37l-4.08,2.36c.07,.08,.13,.17,.2,.26Z",
						fill: "#ec6f19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.88,21.32s-.03,0-.05,0c-.1-.04-.19-.11-.26-.19l-.32,.18c.07,.09,.16,.16,.25,.23l.37-.21Z",
						fill: "#ec6f19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.31,4.7l3.69-2.13v-.37l-3.89,2.24c.07,.09,.13,.17,.2,.26Z",
						fill: "#ec7019"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.12,21.37c-.09,0-.17-.02-.24-.05l-.37,.21c.11,.08,.24,.13,.37,.16l.56-.32h-.32Z",
						fill: "#ec7019"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.51,4.96l3.49-2.02v-.37l-3.69,2.13c.06,.09,.13,.17,.2,.26Z",
						fill: "#ec7119"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.44,21.37l-.56,.32c.08,.02,.16,.05,.24,.05h.32l.65-.37h-.65Z",
						fill: "#ec7119"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.68,5.24l3.32-1.92v-.37l-3.49,2.02c.06,.09,.11,.18,.17,.28Z",
						fill: "#ed7219"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "2.09 21.37 1.44 21.74 2.09 21.74 2.74 21.37 2.09 21.37",
						fill: "#ed7219"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "2.74 21.37 2.09 21.74 2.74 21.74 3.39 21.37 2.74 21.37",
						fill: "#ed731a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.85,5.52l3.15-1.82v-.37l-3.32,1.92c.06,.09,.11,.18,.17,.28Z",
						fill: "#ed731a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "3.39 21.37 2.74 21.74 3.39 21.74 4.04 21.37 3.39 21.37",
						fill: "#ed741a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.02,5.79l2.98-1.72v-.37l-3.15,1.82c.06,.09,.12,.18,.17,.28Z",
						fill: "#ed741a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.16,6.08l2.84-1.64v-.37l-2.98,1.72c.05,.09,.1,.19,.15,.29Z",
						fill: "#ed751a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "4.04 21.37 3.39 21.74 4.04 21.74 4.69 21.37 4.04 21.37",
						fill: "#ed751a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.31,6.38l2.69-1.56v-.37l-2.84,1.64c.05,.1,.09,.2,.14,.29Z",
						fill: "#ee761a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "4.69 21.37 4.04 21.74 4.69 21.74 5.33 21.37 4.69 21.37",
						fill: "#ee761a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "5.33 21.37 4.69 21.74 5.34 21.74 5.98 21.37 5.33 21.37",
						fill: "#ee771a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.45,6.67l2.55-1.47v-.37l-2.69,1.56c.05,.1,.1,.19,.14,.29Z",
						fill: "#ee771a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.57,6.97l2.43-1.4v-.37l-2.55,1.47c.04,.1,.08,.2,.12,.3Z",
						fill: "#ee781a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "5.98 21.37 5.34 21.74 5.99 21.74 6.63 21.37 5.98 21.37",
						fill: "#ee781a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "6.63 21.37 5.99 21.74 6.64 21.74 7.28 21.37 6.63 21.37",
						fill: "#ef791a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.68,7.28l2.32-1.34v-.37l-2.43,1.4c.04,.1,.08,.21,.11,.31Z",
						fill: "#ef791a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "7.28 21.37 6.64 21.74 7.29 21.74 7.93 21.37 7.28 21.37",
						fill: "#ef7a1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.8,7.59l2.2-1.27v-.37l-2.32,1.34c.04,.1,.08,.2,.11,.31Z",
						fill: "#ef7a1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.9,7.91l2.1-1.21v-.37l-2.2,1.27c.03,.11,.07,.21,.1,.32Z",
						fill: "#ef7b1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "7.93 21.37 7.29 21.74 7.93 21.74 8.58 21.37 7.93 21.37",
						fill: "#ef7b1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.98,8.24l2.02-1.17v-.37l-2.1,1.21c.03,.11,.06,.22,.08,.33Z",
						fill: "#ef7c1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "8.58 21.37 7.93 21.74 8.58 21.74 9.23 21.37 8.58 21.37",
						fill: "#ef7c1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.06,8.56l1.94-1.12v-.37l-2.02,1.17c.03,.11,.06,.22,.08,.33Z",
						fill: "#f07d1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "9.23 21.37 8.58 21.74 9.23 21.74 9.88 21.37 9.23 21.37",
						fill: "#f07d1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "9.88 21.37 9.23 21.74 9.88 21.74 10.53 21.37 9.88 21.37",
						fill: "#f07e1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.14,8.9l1.86-1.08v-.37l-1.94,1.12c.02,.11,.05,.22,.07,.33Z",
						fill: "#f07e1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.19,9.24l1.81-1.05v-.37l-1.86,1.08c.02,.11,.03,.23,.05,.34Z",
						fill: "#f07f1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "10.53 21.37 9.88 21.74 10.53 21.74 11.18 21.37 10.53 21.37",
						fill: "#f07f1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.24,9.59l1.76-1.02v-.37l-1.81,1.05c.02,.11,.04,.23,.05,.34Z",
						fill: "#f0801b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "11.18 21.37 10.53 21.74 11.18 21.74 11.83 21.37 11.18 21.37",
						fill: "#f0801b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "11.83 21.37 11.18 21.74 11.83 21.74 12.48 21.37 11.83 21.37",
						fill: "#f1801c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.28,9.94l1.72-.99v-.37l-1.76,1.02c.01,.12,.03,.23,.04,.35Z",
						fill: "#f1801c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.3,10.3l1.7-.98v-.37l-1.72,.99c.01,.12,.01,.24,.02,.36Z",
						fill: "#f1811c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "12.48 21.37 11.83 21.74 12.48 21.74 13.13 21.37 12.48 21.37",
						fill: "#f1811c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.32,10.67l1.68-.97v-.37l-1.7,.98c0,.12,.02,.24,.02,.36Z",
						fill: "#f1821c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "13.13 21.37 12.48 21.74 13.13 21.74 13.78 21.37 13.13 21.37",
						fill: "#f1821c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "13.78 21.37 13.13 21.74 13.78 21.74 14.42 21.37 13.78 21.37",
						fill: "#f1831c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.33,10.87c0,.06,0,.11,0,.17l1.68-.97v-.37l-1.68,.97c0,.07,.01,.14,.01,.21Z",
						fill: "#f1831c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "14.42 21.37 13.78 21.74 14.43 21.74 15.07 21.37 14.42 21.37",
						fill: "#f2841c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.3,11.43l1.7-.98v-.37l-1.68,.97c0,.13-.01,.26-.02,.39Z",
						fill: "#f2841c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.28,11.81l1.72-.99v-.37l-1.7,.98c0,.13,0,.26-.02,.39Z",
						fill: "#f2851c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "15.07 21.37 14.43 21.74 15.08 21.74 15.72 21.37 15.07 21.37",
						fill: "#f2851c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.23,12.21l1.77-1.02v-.37l-1.72,.99c-.01,.14-.03,.27-.05,.4Z",
						fill: "#f2861c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "15.72 21.37 15.08 21.74 15.73 21.74 16.37 21.37 15.72 21.37",
						fill: "#f2861c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "16.37 21.37 15.73 21.74 16.38 21.74 17.02 21.37 16.37 21.37",
						fill: "#f2871d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.17,12.63l1.83-1.06v-.37l-1.77,1.02c-.02,.14-.04,.27-.06,.41Z",
						fill: "#f2871d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.1,13.04l1.9-1.1v-.37l-1.83,1.06c-.02,.14-.04,.28-.07,.41Z",
						fill: "#f3881d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "17.02 21.37 16.38 21.74 17.02 21.74 17.67 21.37 17.02 21.37",
						fill: "#f3881d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.99,13.48l2.01-1.16v-.37l-1.9,1.1c-.03,.15-.08,.29-.11,.44Z",
						fill: "#f3891d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "17.67 21.37 17.02 21.74 17.67 21.74 18.32 21.37 17.67 21.37",
						fill: "#f3891d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.87,13.92l2.13-1.23v-.37l-2.01,1.16c-.04,.15-.07,.3-.11,.44Z",
						fill: "#f38a1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "18.32 21.37 17.67 21.74 18.32 21.74 18.97 21.37 18.32 21.37",
						fill: "#f38a1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "18.97 21.37 18.32 21.74 18.97 21.74 19.62 21.37 18.97 21.37",
						fill: "#f48b1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.71,14.39l2.29-1.32v-.37l-2.13,1.23c-.05,.16-.11,.31-.16,.47Z",
						fill: "#f48b1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.54,14.87l2.46-1.42v-.37l-2.29,1.32c-.06,.16-.11,.32-.17,.48Z",
						fill: "#f48c1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "19.62 21.37 18.97 21.74 19.62 21.74 20.27 21.37 19.62 21.37",
						fill: "#f48c1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.3,15.38l2.7-1.56v-.37l-2.46,1.42c-.07,.17-.15,.34-.24,.51Z",
						fill: "#f48d1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "20.27 21.37 19.62 21.74 20.27 21.74 20.92 21.37 20.27 21.37",
						fill: "#f48d1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.05,15.9l2.95-1.7v-.37l-2.7,1.56c-.08,.17-.16,.35-.25,.52Z",
						fill: "#f48e1e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "20.92 21.37 20.27 21.74 20.92 21.74 21.57 21.37 20.92 21.37",
						fill: "#f48e1e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.83,21.37h-.26l-.65,.37h.65l.68-.39c-.14,0-.28,.02-.42,.02Z",
						fill: "#f58f1e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.7,16.47l3.3-1.91v-.37l-2.95,1.7c-.11,.2-.23,.39-.35,.58Z",
						fill: "#f58f1e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.27,17.1l3.73-2.15v-.37l-3.3,1.91c-.13,.21-.28,.42-.43,.62Z",
						fill: "#f5901e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.25,21.35l-.68,.39h.65l.76-.44c-.24,.03-.48,.03-.73,.04Z",
						fill: "#f5901e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.71,17.8l4.29-2.48v-.37l-3.73,2.15c-.18,.24-.37,.47-.56,.7Z",
						fill: "#f5911e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.98,21.3l-.76,.44h.65l.99-.57c-.29,.06-.58,.1-.88,.13Z",
						fill: "#f5911e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M23.86,21.17l-.99,.57h.65l1.52-.88c-.38,.12-.77,.22-1.17,.3Z",
						fill: "#f5921e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.84,18.67l5.16-2.98v-.37l-4.29,2.48c-.27,.31-.56,.6-.87,.88Z",
						fill: "#f5921e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.04,20.87l-1.52,.88h.65l9.83-5.68v-.37l-5.16,2.98c-1.09,.98-2.38,1.74-3.8,2.2Z",
						fill: "#f6931e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "24.82 21.74 34 16.44 34 16.07 24.17 21.74 24.82 21.74",
						fill: "#f6941e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "25.47 21.74 34 16.82 34 16.44 24.82 21.74 25.47 21.74",
						fill: "#f6951e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "26.11 21.74 34 17.19 34 16.82 25.47 21.74 26.11 21.74",
						fill: "#f6961f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "26.76 21.74 34 17.57 34 17.19 26.11 21.74 26.76 21.74",
						fill: "#f7971f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "27.41 21.74 34 17.94 34 17.57 26.76 21.74 27.41 21.74",
						fill: "#f7981f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "28.06 21.74 34 18.32 34 17.94 27.41 21.74 28.06 21.74",
						fill: "#f7991f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "28.71 21.74 34 18.69 34 18.32 28.06 21.74 28.71 21.74",
						fill: "#f79a1f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "29.36 21.74 34 19.07 34 18.69 28.71 21.74 29.36 21.74",
						fill: "#f89b1f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "30.01 21.74 34 19.44 34 19.07 29.36 21.74 30.01 21.74",
						fill: "#f89c1f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "30.66 21.74 34 19.82 34 19.44 30.01 21.74 30.66 21.74",
						fill: "#f89d20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "31.31 21.74 34 20.19 34 19.82 30.66 21.74 31.31 21.74",
						fill: "#f89e20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "31.96 21.74 34 20.57 34 20.19 31.31 21.74 31.96 21.74",
						fill: "#f99f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.88,21.74c.62,0,1.12-.5,1.12-1.12v-.06l-2.04,1.18h.92Z",
						fill: "#f9a020"
					},
					children: [
					]
				}
			]
		}
	]
};
var generic = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 20"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M30.5,20h-29C0.7,20,0,19.3,0,18.5v-17C0,0.7,0.7,0,1.5,0h29C31.3,0,32,0.7,32,1.5v17C32,19.3,31.3,20,30.5,20z M1.5,1\n\t\t\tC1.2,1,1,1.2,1,1.5v17C1,18.8,1.2,19,1.5,19h29c0.3,0,0.5-0.2,0.5-0.5v-17C31,1.2,30.8,1,30.5,1H1.5z"
							},
							children: [
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "4",
								y: "4",
								"fill-rule": "evenodd",
								"clip-rule": "evenodd",
								width: "24",
								height: "2"
							},
							children: [
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "23",
								y: "14",
								"fill-rule": "evenodd",
								"clip-rule": "evenodd",
								width: "2",
								height: "2"
							},
							children: [
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "26",
								y: "14",
								"fill-rule": "evenodd",
								"clip-rule": "evenodd",
								width: "2",
								height: "2"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
};
var jcb = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "_レイヤー_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 34 26.19"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M34,20.91c0,2.91-2.37,5.28-5.28,5.28H0V5.28C0,2.37,2.37,0,5.28,0h28.72V20.91Z",
				fill: "#fff"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M24.65,15.55h2.18l.27-.02c.42-.08,.77-.46,.77-.98s-.35-.87-.77-.98l-.27-.02h-2.18v2Z",
				fill: "#469b23"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M26.58,1.77c-2.08,0-3.78,1.68-3.78,3.78v3.93h5.34c.12,0,.27,0,.37,.02,1.21,.06,2.1,.69,2.1,1.77,0,.85-.6,1.58-1.72,1.72v.04c1.23,.08,2.16,.77,2.16,1.83,0,1.14-1.04,1.89-2.41,1.89h-5.86v7.69h5.55c2.08,0,3.78-1.68,3.78-3.78V1.77h-5.53Z",
				fill: "#469b23"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M27.6,11.51c0-.5-.35-.83-.77-.89l-.21-.02h-1.97v1.83h1.97l.21-.02c.42-.06,.77-.39,.77-.89Z",
				fill: "#469b23"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.67,1.77c-2.08,0-3.78,1.68-3.78,3.78V14.88c1.06,.52,2.16,.85,3.26,.85,1.31,0,2.02-.79,2.02-1.87v-4.41h3.24v4.39c0,1.7-1.06,3.1-4.66,3.1-2.18,0-3.89-.48-3.89-.48v7.96H7.42c2.08,0,3.78-1.68,3.78-3.78V1.77H5.67Z",
				fill: "#0c2c84"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.13,1.77c-2.08,0-3.78,1.68-3.78,3.78v4.95c.96-.81,2.62-1.33,5.3-1.21,1.43,.06,2.97,.46,2.97,.46v1.6c-.77-.39-1.68-.75-2.87-.83-2.04-.15-3.26,.85-3.26,2.6s1.23,2.76,3.26,2.6c1.18-.08,2.1-.46,2.87-.83v1.6s-1.52,.39-2.97,.46c-2.68,.12-4.34-.39-5.3-1.21v8.73h5.55c2.08,0,3.78-1.68,3.78-3.78V1.77h-5.55Z",
				fill: "#d7182a"
			},
			children: [
			]
		}
	]
};
var mastercard = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 20"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						x: "11.241",
						y: "2.224",
						fill: "#FF5F00",
						width: "9.521",
						height: "15.55"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#EB001B",
						d: "M12.222,10.001c-0.002-3.034,1.39-5.9,3.777-7.774C11.705-1.148,5.488-0.402,2.113,3.892\n\t\ts-2.629,10.511,1.665,13.885c3.586,2.818,8.635,2.818,12.221,0C13.611,15.903,12.219,13.036,12.222,10.001z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#F79E1B",
						d: "M31.054,16.129V15.81h0.137v-0.066h-0.327v0.066h0.129v0.319H31.054z M31.689,16.129v-0.385H31.59\n\t\tl-0.115,0.275l-0.115-0.275H31.26v0.385h0.071v-0.291l0.107,0.25h0.074l0.107-0.25v0.291L31.689,16.129z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#F79E1B",
						d: "M31.999,10.001c0,5.461-4.428,9.889-9.889,9.888c-2.217,0-4.369-0.745-6.112-2.115\n\t\tc4.294-3.375,5.039-9.591,1.665-13.885c-0.487-0.619-1.045-1.178-1.665-1.665c4.293-3.375,10.51-2.631,13.886,1.662\n\t\tc1.37,1.743,2.115,3.895,2.115,6.112V10.001z"
					},
					children: [
					]
				}
			]
		}
	]
};
var placeholder = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 20"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#D8DADA",
								d: "M30.5,20h-29C0.7,20,0,19.3,0,18.5v-17C0,0.7,0.7,0,1.5,0h29C31.3,0,32,0.7,32,1.5v17\n\t\t\tC32,19.3,31.3,20,30.5,20z M1.5,1C1.2,1,1,1.2,1,1.5v17C1,18.8,1.2,19,1.5,19h29c0.3,0,0.5-0.2,0.5-0.5v-17C31,1.2,30.8,1,30.5,1\n\t\t\tH1.5z"
							},
							children: [
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "4",
								y: "4",
								"fill-rule": "evenodd",
								"clip-rule": "evenodd",
								fill: "#D8DADA",
								width: "24",
								height: "2"
							},
							children: [
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "23",
								y: "14",
								"fill-rule": "evenodd",
								"clip-rule": "evenodd",
								fill: "#D8DADA",
								width: "2",
								height: "2"
							},
							children: [
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "26",
								y: "14",
								"fill-rule": "evenodd",
								"clip-rule": "evenodd",
								fill: "#D8DADA",
								width: "2",
								height: "2"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
};
var securityCode = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 96 71.4298",
		style: "enable-background:new 0 0 96 71.4298;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M81.73517,71.05779H2.46222c-1.17732,0-1.9622-0.78488-1.9622-1.9622V21.02164c0-1.17732,0.78488-1.9622,1.9622-1.9622\n\t\th79.37106c1.17732,0,1.9622,0.78488,1.9622,1.9622l-0.09811,48.07394C83.69737,70.2729,82.91249,71.05779,81.73517,71.05779z\n\t\t M81.83327,21.02164H2.46222v48.07395h79.27295L81.83327,21.02164z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.38301,25.43659h82.02003v1.9622H1.38301V25.43659z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.38301,34.26651h82.02003v1.9622H1.38301V34.26651z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M48.08341,42.60586h12.45998v1.9622H48.08341V42.60586z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						"fill-rule": "evenodd",
						"clip-rule": "evenodd",
						fill: "#FFFFFF",
						d: "M90.85941,31.71564c6.27905-8.43747,4.31684-20.60312-4.21874-26.78405s-20.505-4.12062-26.78405,4.41495\n\t\tc-5.7885,7.94692-4.61118,18.93525,2.64897,25.41051l-0.09811,3.63008l3.43385-1.17732\n\t\tC74.18069,41.91909,84.97281,39.76067,90.85941,31.71564z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M75.2599,40.64366c-3.23763,0-6.47527-0.78488-9.41856-2.35464l-4.31684,1.47165l0.09811-4.61118\n\t\tc-7.35826-6.86771-8.43747-18.15037-2.45275-26.39161c6.47526-9.02613,19.13147-11.08644,28.05948-4.61117\n\t\tc4.41496,3.13952,7.26015,7.84881,8.04503,13.24486c0.78488,5.29794-0.49055,10.59589-3.63007,14.91273\n\t\tC87.71989,37.70036,81.53896,40.64366,75.2599,40.64366z M65.93945,36.13059l0.39244,0.19622\n\t\tc8.04503,4.51306,18.24847,2.25653,23.74264-5.19983c2.8452-3.82629,4.02251-8.63369,3.23764-13.44108\n\t\tc-0.78488-4.9055-3.33575-9.12424-7.26015-11.96943c-8.04503-5.7885-19.4258-3.9244-25.41052,4.21873\n\t\tc-5.49416,7.55448-4.41495,17.95415,2.55086,24.13508l0.29433,0.29433l-0.09811,2.64898L65.93945,36.13059z"
					},
					children: [
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
						"enable-background": "new"
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M67.41109,19.35377H65.547v-1.27543c1.17731,0,2.06031-0.58866,2.25654-1.66787h1.47165v8.14314h-1.8641V19.35377z"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M71.92416,22.29707c0.58865-0.58866,1.27543-1.07921,1.9622-1.56976c0.9811-0.68677,1.47166-0.9811,1.47166-1.76598\n\t\t\tc0-0.68677-0.39245-1.07921-1.07922-1.07921c-0.39244,0-0.68677,0.09811-0.88299,0.39244\n\t\t\tc-0.29433,0.29433-0.39244,0.68677-0.39244,1.17732h-1.76598c0-0.78488,0.19621-1.37354,0.49055-1.86409\n\t\t\tc0.49055-0.68677,1.27544-1.17732,2.64897-1.17732c1.86409,0,2.9433,1.17732,2.9433,2.55086s-0.9811,2.15842-2.15842,2.84519\n\t\t\tc-0.78488,0.49055-1.17731,0.68677-1.47165,1.17732h3.63007v1.56976h-6.18094\n\t\t\tC71.04117,23.5725,71.3355,22.88573,71.92416,22.29707z"
							},
							children: [
							]
						}
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M79.38052,23.86683c-0.58865-0.49055-0.9811-1.17732-0.9811-2.06031h1.76599\n\t\tc0.09811,0.78488,0.49055,1.27543,1.47165,1.27543c0.78488,0,1.27544-0.39244,1.27544-1.17732\n\t\tc0-0.68677-0.49055-1.07921-1.37354-1.07921h-0.39245v-1.27543h0.39245c0.78488,0,1.17731-0.39244,1.17731-0.9811\n\t\tc0-0.49055-0.39244-0.9811-1.07921-0.9811c-0.883,0-1.17732,0.58866-1.27544,1.17732h-1.76598\n\t\tc0-1.37354,1.17731-2.55086,3.04141-2.55086c1.66787,0,2.84519,0.78488,2.84519,2.15842c0,0.78488-0.49055,1.27543-1.27544,1.56976\n\t\tc0.9811,0.29433,1.56976,0.88299,1.56976,1.9622c0,1.66787-1.47165,2.74708-3.04141,2.74708\n\t\tC80.65596,24.65171,79.96918,24.25928,79.38052,23.86683z"
					},
					children: [
					]
				}
			]
		}
	]
};
var securityCodeAmex = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 96.9 71.9",
		style: "enable-background:new 0 0 96.9 71.9;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M82.61,71.539H2.43c-1.188,0-1.98-0.792-1.98-1.98V21.055c0-1.188,0.792-1.98,1.98-1.98h80.18\n\t\t\tc1.188,0,1.98,0.792,1.98,1.98v48.504C84.589,70.747,83.798,71.539,82.61,71.539z M2.43,21.055v48.504h80.18V21.055\n\t\t\tC82.61,21.055,2.43,21.055,2.43,21.055z"
							},
							children: [
							]
						},
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "63.604",
								y: "44.812",
								width: "14.848",
								height: "1.98"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M20.248,43.823h-7.919c-1.683,0-2.97-1.287-2.97-2.97v-4.949c0-1.683,1.287-2.97,2.97-2.97h7.919\n\t\t\tc1.683,0,2.97,1.287,2.97,2.97v4.949C23.217,42.536,21.93,43.823,20.248,43.823z M12.328,34.914c-0.594,0-0.99,0.396-0.99,0.99\n\t\t\tv4.949c0,0.594,0.396,0.99,0.99,0.99h7.919c0.594,0,0.99-0.396,0.99-0.99v-4.949c0-0.594-0.396-0.99-0.99-0.99H12.328z"
							},
							children: [
							]
						},
						{
							name: "g",
							type: "element",
							value: "",
							attributes: {
							},
							children: [
								{
									name: "path",
									type: "element",
									value: "",
									attributes: {
										"fill-rule": "evenodd",
										"clip-rule": "evenodd",
										fill: "#FFFFFF",
										d: "M93.696,28.776c4.454-9.701,0.396-21.183-9.305-25.638s-21.183-0.396-25.638,9.305\n\t\t\t\tc-4.256,9.008-0.792,19.6,7.424,24.648l0.594,3.663l3.267-1.881C79.244,42.041,89.44,37.784,93.696,28.776z"
									},
									children: [
									]
								},
								{
									name: "path",
									type: "element",
									value: "",
									attributes: {
										d: "M65.98,42.338l-0.693-4.652c-8.612-5.543-11.78-16.432-7.424-25.638c2.277-4.949,6.335-8.612,11.384-10.493\n\t\t\t\tc5.048-1.782,10.592-1.584,15.541,0.693c10.097,4.652,14.452,16.729,9.8,26.925l0,0c-4.355,9.305-14.848,13.858-24.45,10.79\n\t\t\t\tL65.98,42.338z M76.176,2.347c-2.079,0-4.256,0.396-6.236,1.089c-4.553,1.683-8.216,5.048-10.295,9.404\n\t\t\t\tc-3.96,8.414-0.99,18.511,7.028,23.361l0.396,0.198l0.396,2.673l2.376-1.386l0.396,0.099c8.81,3.069,18.412-1.089,22.47-9.602\n\t\t\t\tc4.256-9.206,0.297-20.094-8.81-24.351C81.521,2.941,78.848,2.347,76.176,2.347z"
									},
									children: [
									]
								}
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
						"enable-background": "new"
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M64.198,19.472h-1.881v-1.287c1.188,0,2.079-0.594,2.277-1.683h1.485v8.216h-1.881V19.472z"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M68.751,22.441c0.594-0.594,1.287-1.089,1.98-1.584c0.99-0.693,1.485-0.99,1.485-1.782c0-0.693-0.396-1.089-1.089-1.089\n\t\t\tc-0.396,0-0.693,0.099-0.891,0.396c-0.297,0.297-0.396,0.693-0.396,1.188h-1.782c0-0.792,0.198-1.386,0.495-1.881\n\t\t\tc0.495-0.693,1.287-1.188,2.673-1.188c1.881,0,2.97,1.188,2.97,2.574s-0.99,2.178-2.178,2.871\n\t\t\tc-0.792,0.495-1.188,0.693-1.485,1.188l0,0h3.663v1.584H67.96C67.96,23.728,68.158,23.035,68.751,22.441z"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M86.767,22.936h-3.762v-1.683l3.762-4.652h1.881v4.949h1.188v1.386h-1.188v1.782h-1.881V22.936z M85.381,21.451h1.386\n\t\t\tv-1.881c0-0.495,0-0.891,0.099-1.287l0,0c-0.198,0.297-0.495,0.693-0.792,1.089l-0.792,0.99c-0.396,0.396-0.693,0.792-0.891,1.089\n\t\t\tl0,0C84.589,21.55,84.985,21.451,85.381,21.451z"
							},
							children: [
							]
						}
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M76.275,24.124c-0.594-0.495-0.99-1.188-0.99-2.079h1.782c0.099,0.792,0.495,1.287,1.485,1.287\n\t\tc0.792,0,1.287-0.396,1.287-1.188c0-0.693-0.495-1.089-1.386-1.089h-0.396v-1.287h0.396c0.792,0,1.188-0.396,1.188-0.99\n\t\tc0-0.495-0.396-0.99-1.089-0.99c-0.891,0-1.188,0.594-1.287,1.188h-1.782c0-1.386,1.188-2.574,3.069-2.574\n\t\tc1.683,0,2.871,0.792,2.871,2.178c0,0.792-0.495,1.287-1.287,1.584l0,0c0.99,0.297,1.584,0.891,1.584,1.98\n\t\tc0,1.683-1.485,2.772-3.069,2.772C77.66,24.916,76.868,24.619,76.275,24.124z"
					},
					children: [
					]
				}
			]
		}
	]
};
var visa = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 34 10.98"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.91,.19l-4.45,10.62h-2.9L3.36,2.34c-.13-.52-.25-.71-.65-.93-.66-.36-1.75-.69-2.71-.9L.07,.19H4.74c.6,0,1.13,.4,1.27,1.08l1.16,6.15L10.02,.19h2.89Zm11.38,7.15c.01-2.8-3.88-2.96-3.85-4.21,0-.38,.37-.79,1.17-.89,.39-.05,1.48-.09,2.71,.48l.48-2.25c-.66-.24-1.51-.47-2.57-.47-2.72,0-4.63,1.44-4.64,3.51-.02,1.53,1.36,2.38,2.4,2.89,1.07,.52,1.43,.85,1.43,1.32,0,.71-.85,1.03-1.65,1.04-1.38,.02-2.18-.37-2.82-.67l-.5,2.33c.64,.29,1.83,.55,3.06,.56,2.89,0,4.77-1.43,4.78-3.63m7.17,3.47h2.54L31.78,.19h-2.35c-.53,0-.97,.31-1.17,.78l-4.12,9.84h2.88l.57-1.59h3.52l.33,1.59Zm-3.07-3.76l1.45-3.99,.83,3.99h-2.28ZM16.83,.19l-2.27,10.62h-2.75L14.09,.19h2.75Z",
				fill: "#1434cb"
			},
			children: [
			]
		}
	]
};
var CardData = {
	amex: amex,
	"dinersClub-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 34.02 23.73"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.69,15.12c0-.65-.33-.6-.66-.61v-.19c.28,.01,.57,.01,.85,.01,.3,0,.71-.01,1.25-.01,1.86,0,2.87,1.25,2.87,2.52,0,.71-.41,2.51-2.96,2.51-.37,0-.7-.01-1.05-.01s-.65,0-.97,.01v-.19c.43-.04,.63-.06,.66-.55v-3.49h.01Zm.7,3.38c0,.56,.4,.62,.75,.62,1.56,0,2.06-1.17,2.06-2.24,0-1.35-.86-2.32-2.25-2.32-.29,0-.43,.02-.56,.03v3.91h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M5.25,19.15h.13c.2,0,.35,0,.35-.23v-1.95c0-.31-.11-.36-.38-.5v-.11c.33-.1,.75-.23,.77-.26,.06-.03,.09-.03,.13-.03s.04,.04,.04,.1v2.76c0,.23,.16,.23,.36,.23h.12v.19c-.25,0-.5-.01-.76-.01s-.51,0-.78,.01v-.19h.01Zm.77-4.22c-.19,0-.36-.18-.36-.36s.17-.35,.36-.35,.36,.16,.36,.35-.16,.36-.36,.36",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M7.48,17.01c0-.27-.08-.33-.41-.48v-.13c.31-.1,.6-.19,.95-.35,.02,0,.04,.01,.04,.07v.47c.41-.3,.77-.53,1.25-.53,.61,0,.82,.45,.82,1v1.86c0,.23,.16,.23,.36,.23h.13v.19c-.26,0-.5-.01-.76-.01s-.52,0-.78,.01v-.19h.13c.2,0,.35,0,.35-.23v-1.86c0-.41-.26-.61-.66-.61-.23,0-.6,.19-.84,.35v2.13c0,.23,.16,.23,.36,.23h.13v.19c-.26,0-.5-.01-.77-.01s-.51,0-.78,.01v-.19h.13c.2,0,.35,0,.35-.23v-1.9h-.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M11.15,17.36c-.01,.07-.01,.17,0,.41,.04,.68,.48,1.25,1.06,1.25,.4,0,.7-.21,.97-.48l.1,.1c-.33,.43-.74,.81-1.33,.81-1.15,0-1.37-1.1-1.37-1.57,0-1.41,.95-1.83,1.45-1.83,.58,0,1.21,.37,1.21,1.13v.13l-.07,.04h-2.03Zm1.27-.23c.18,0,.2-.09,.2-.18,0-.37-.22-.66-.62-.66-.43,0-.74,.32-.82,.85h1.25Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M13.41,19.15h.19c.2,0,.35,0,.35-.23v-2.02c0-.22-.27-.27-.38-.32v-.11c.52-.22,.81-.41,.88-.41,.04,0,.07,.02,.07,.09v.65h.01c.18-.28,.48-.74,.92-.74,.18,0,.41,.12,.41,.38,0,.19-.13,.37-.33,.37-.22,0-.22-.18-.48-.18-.12,0-.52,.17-.52,.6v1.69c0,.23,.14,.23,.35,.23h.4v.19c-.4,0-.7-.01-1-.01s-.6,0-.86,.01c0,0,0-.19,0-.19Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M16.19,18.34c.09,.48,.38,.88,.9,.88,.42,0,.58-.26,.58-.51,0-.85-1.57-.58-1.57-1.74,0-.4,.32-.92,1.11-.92,.23,0,.53,.07,.82,.21l.06,.74h-.17c-.07-.46-.32-.71-.78-.71-.29,0-.56,.17-.56,.48,0,.85,1.67,.58,1.67,1.72,0,.48-.38,.98-1.24,.98-.29,0-.62-.1-.88-.25l-.08-.82,.13-.03h-.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.74,15.62h-.18c-.13-.85-.74-1.18-1.54-1.18s-2.03,.56-2.03,2.28c0,1.46,1.04,2.5,2.14,2.5,.71,0,1.3-.49,1.45-1.25l.17,.04-.17,1.05c-.3,.19-1.11,.38-1.59,.38-1.68,0-2.75-1.08-2.75-2.71,0-1.47,1.31-2.53,2.73-2.53,.58,0,1.15,.19,1.69,.38l.07,1.02h.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25,19.15h.13c.2,0,.35,0,.35-.23v-4c0-.47-.11-.48-.38-.56v-.11c.29-.09,.59-.22,.75-.31,.08-.04,.13-.08,.16-.08,.04,0,.06,.04,.06,.1v4.97c0,.23,.16,.23,.36,.23h.12v.19c-.25,0-.5-.01-.76-.01s-.51,0-.78,.01v-.19h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.62,18.94c0,.13,.08,.13,.2,.13h.29v.16c-.31,.03-.9,.18-1.04,.22l-.03-.02v-.58c-.43,.36-.76,.6-1.27,.6-.39,0-.79-.26-.79-.86v-1.84c0-.19-.03-.37-.43-.4v-.13c.26,0,.84-.04,.92-.04,.08,0,.08,.04,.08,.21v1.86c0,.21,0,.84,.62,.84,.25,0,.57-.19,.87-.43v-1.94c0-.14-.35-.22-.6-.29v-.13c.65-.04,1.05-.1,1.13-.1,.06,0,.06,.04,.06,.13v2.62Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.05,16.57c.29-.25,.68-.51,1.07-.51,.84,0,1.34,.72,1.34,1.52,0,.95-.69,1.88-1.72,1.88-.53,0-.81-.17-1-.26l-.21,.17-.16-.08c.07-.42,.1-.85,.1-1.28v-3.1c0-.47-.11-.48-.38-.56v-.11c.29-.09,.59-.22,.75-.31,.08-.04,.13-.08,.16-.08,.04,0,.06,.04,.06,.1v2.63h0Zm0,1.95c0,.28,.26,.74,.75,.74,.77,0,1.09-.76,1.09-1.39,0-.78-.59-1.43-1.15-1.43-.27,0-.49,.18-.68,.33v1.75h-.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.02,23.52h.06c.14,0,.29-.02,.29-.22v-2.05c0-.2-.14-.22-.29-.22H.02v-.12c.16,0,.39,.01,.58,.01s.43-.01,.61-.01v.12h-.06c-.14,0-.29,.02-.29,.22v2.05c0,.2,.14,.22,.29,.22h.06v.12c-.19,0-.42-.01-.61-.01s-.42,.01-.58,.01c0,0,0-.12,0-.12Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.21,23.65c-.19,0-.42-.01-.61-.01s-.42,.01-.58,.01H0v-.16H.07c.14,0,.27-.01,.27-.21v-2.05c0-.19-.13-.2-.27-.21h-.07v-.16H.02c.16,0,.39,.01,.58,.01s.42-.01,.61-.01h.02v.16h-.07c-.14,0-.27,.01-.28,.21v2.05c0,.19,.13,.2,.28,.21h.07v.16s-.02,0-.02,0Zm-.02-.03v-.08h-.03c-.14,0-.31-.02-.31-.25v-2.05c0-.21,.17-.25,.31-.25h.03v-.08c-.18,0-.41,.01-.6,.01s-.41-.01-.56-.01v.08h.03c.14,0,.3,.02,.3,.25v2.05c0,.21-.17,.25-.3,.25H.03v.08c.16,0,.37-.01,.56-.01s.41,.01,.6,.01",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M3.9,22.87h0v-1.47c0-.32-.22-.37-.35-.37h-.09v-.12c.18,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01v.12h-.06c-.17,0-.35,.03-.35,.5v1.78c0,.13,0,.28,.02,.39h-.14l-2.02-2.25v1.62c0,.35,.07,.46,.37,.46h.07v.12c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01v-.12h.06c.27,0,.36-.18,.36-.5v-1.65c0-.22-.18-.36-.36-.36h-.06v-.12c.14,0,.3,.01,.45,.01,.12,0,.23-.01,.35-.01l1.74,1.96h.02Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M4.12,23.72h-.16l-1.98-2.22v1.57c0,.35,.06,.43,.36,.45h.09v.16h-.02c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01h-.02v-.16h.08c.26,0,.33-.17,.33-.48v-1.65c0-.21-.17-.33-.33-.33h-.07v-.16h.02c.14,0,.3,.01,.45,.01,.11,0,.23-.01,.36,0l1.72,1.94v-1.44c0-.31-.21-.35-.32-.36h-.1v-.16h.02c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01h.02v.16h-.08c-.17,0-.32,.02-.33,.48v1.78c0,.13,0,.27,.02,.39v.02h-.03Zm-.14-.04h.13c-.02-.12-.02-.25-.02-.38v-1.78c0-.47,.2-.51,.37-.51h.04v-.08c-.16,0-.31,.01-.47,.01-.18,0-.36-.01-.53-.01v.08h.07c.12,0,.36,.06,.36,.39v1.48h-.02l-1.74-1.96c-.11,0-.23,.01-.35,.01-.14,0-.29-.01-.43-.01v.08h.03c.18,0,.37,.14,.37,.37v1.65c0,.31-.09,.51-.37,.51h-.03v.08c.17,0,.35-.01,.51-.01s.32,.01,.49,.01v-.08h-.04c-.31,0-.39-.13-.39-.48v-1.66l2.03,2.27v.02Zm-.08-.81h0Zm0,0h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M5.09,21.1c-.29,0-.3,.07-.37,.36h-.12c.01-.11,.03-.22,.04-.33,.01-.11,.02-.22,.02-.33h.09c.03,.12,.13,.11,.23,.11h2.02c.1,0,.2,0,.21-.12h.09c-.01,.12-.03,.22-.04,.33v.31l-.12,.04c0-.14-.03-.38-.29-.38h-.65v2.08c0,.3,.13,.33,.32,.33h.08v.12c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01v-.12h.08c.21,0,.32-.02,.32-.32v-2.09h-.62Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M6.64,23.65c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01h-.01v-.16h.09c.21,0,.3,0,.31-.31v-2.07h-.62v-.02h.66s0,2.09,0,2.09c0,.31-.12,.35-.35,.35h-.06v.08c.16,0,.41-.01,.65-.01,.2,0,.47,.01,.62,.01v-.08h-.06c-.19,0-.35-.04-.35-.36v-2.09h.66c.27,0,.3,.22,.3,.37l.09-.03v-.31c.01-.1,.02-.2,.04-.3h-.06c-.02,.1-.13,.11-.22,.11h-2.04c-.09,0-.19,0-.22-.11h-.07c0,.11,0,.21-.02,.32-.01,.11-.03,.21-.04,.31h.08c.06-.27,.09-.36,.38-.36h0v.03c-.29,0-.28,.06-.35,.35h-.01s-.13,.01-.13,.01v-.02c.02-.11,.03-.22,.06-.33,.01-.11,.02-.21,.02-.33v-.02h.12c.02,.11,.1,.11,.2,.11h2.04c.11,0,.19,0,.19-.11v-.02h.02l.11,.02v.02c-.02,.1-.03,.21-.04,.31v.31h0v.02s-.14,.06-.14,.06v-.02c-.01-.14-.02-.36-.28-.36h-.62v2.06c0,.3,.12,.31,.31,.32h.09v.16h-.06Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M7.46,23.52h.06c.14,0,.29-.02,.29-.22v-2.05c0-.2-.14-.22-.29-.22h-.06v-.12c.23,0,.65,.01,.97,.01s.74-.01,1-.01v.6l-.12,.03c-.02-.26-.07-.46-.48-.46h-.55v1.02h.47c.23,0,.29-.13,.31-.35h.12c0,.16-.01,.3-.01,.46s0,.3,.01,.45l-.12,.02c-.02-.23-.03-.39-.3-.39h-.47v.91c0,.26,.22,.26,.48,.26,.47,0,.68-.03,.79-.48l.11,.02c-.06,.21-.1,.41-.13,.62-.25,0-.7-.01-1.06-.01s-.81,.01-1.04,.01v-.12h.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M9.56,23.65c-.26,0-.7-.01-1.06-.01s-.81,.01-1.04,.01h-.02v-.13h.02s.06-.01,.06-.01c.14,0,.27-.01,.27-.21v-2.05c0-.19-.13-.2-.27-.21h-.07v-.16h.02c.23,0,.65,.01,.97,.01s.74-.01,1-.01h.02v.22c0,.13,0,.28,.01,.39h0v.02s-.14,.03-.14,.03v-.02c-.02-.26-.06-.43-.46-.45h-.52v.99h.45c.22,0,.27-.12,.29-.32h.01s.13-.01,.13-.01v.02c0,.16-.01,.3-.01,.46s0,.3,.01,.45h0v.02s-.14,.02-.14,.02v-.02c-.03-.23-.03-.37-.29-.37h-.46v.89c0,.23,.2,.23,.46,.23,.47,0,.66-.02,.78-.47h.02s.12,.02,.12,.02h0c-.06,.22-.1,.43-.13,.63h-.01s-.02,.02-.02,.02Zm-.01-.03c.03-.2,.08-.39,.12-.59l-.08-.02c-.12,.43-.35,.48-.8,.48-.25,0-.49,0-.49-.27v-.92h.49c.28,0,.3,.17,.32,.39l.09-.02v-.88h-.09c-.02,.2-.09,.35-.32,.35h-.48v-1.06h.56c.41,0,.48,.21,.49,.46l.09-.02v-.57c-.27,0-.66,.01-.98,.01s-.71-.01-.96-.01v.08h.03c.14,0,.3,.02,.31,.25v2.05c0,.21-.17,.23-.31,.25h-.03v.08c.22,0,.68-.01,1.02-.01s.79,.01,1.04,.01",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M10.22,21.32c0-.29-.16-.3-.28-.3h-.07v-.12c.12,0,.37,.01,.61,.01s.42-.01,.63-.01c.49,0,.94,.13,.94,.69,0,.36-.23,.57-.55,.69l.67,1c.11,.17,.19,.21,.38,.23v.12c-.13,0-.26-.01-.38-.01s-.25,.01-.37,.01c-.3-.39-.56-.81-.81-1.27h-.26v.84c0,.3,.14,.31,.32,.31h.07v.12c-.22,0-.45-.01-.67-.01-.19,0-.37,.01-.57,.01v-.12h.07c.14,0,.28-.07,.28-.21v-1.98h-.02Zm.5,.91h.19c.39,0,.6-.14,.6-.61,0-.35-.22-.57-.57-.57-.12,0-.17,.01-.22,.01v1.17Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M12.54,23.65c-.13,0-.26-.01-.39-.01-.12,0-.25,.01-.38,0-.3-.39-.56-.81-.81-1.26h-.23v.82c0,.29,.12,.29,.3,.3h.09v.16h-.02c-.22,0-.46-.01-.67-.01-.19,0-.37,.01-.57,.01h-.01v-.16h.09c.14,0,.26-.07,.26-.19v-1.98c0-.28-.13-.28-.26-.28h-.09v-.16h.01c.12,0,.37,.01,.61,.01s.42-.01,.63-.01c.49,0,.95,.13,.95,.7,0,.36-.23,.58-.53,.7l.66,.98c.11,.17,.18,.2,.37,.22h.01v.16h-.01Zm-1.83-1.31h.27c.26,.46,.51,.88,.8,1.27,.12,0,.25-.01,.37-.01s.25,.01,.37,.01v-.09c-.19-.02-.27-.08-.38-.23l-.68-1.01h.02c.3-.13,.53-.33,.53-.68,0-.55-.42-.67-.91-.67-.21,0-.4,.01-.63,.01s-.47-.01-.59-.01v.08h.06c.12,0,.29,.02,.29,.31v1.98c0,.16-.14,.23-.29,.23h-.06v.08c.19,0,.37-.01,.55-.01,.22,0,.43,.01,.66,.01v-.08h-.06c-.18,0-.33-.02-.33-.33v-.86s.02,0,.02,0Zm0-.11h-.02v-1.2h.01s.11-.01,.22-.01c.36,0,.59,.23,.59,.59,0,.47-.22,.62-.62,.62h-.18Zm.19-.03c.39,0,.58-.13,.59-.59,0-.35-.21-.56-.56-.56-.1,0-.16,0-.2,.01v1.14h.17Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M15.21,22.87h0v-1.47c0-.32-.22-.37-.35-.37h-.09v-.12c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01v.12h-.06c-.17,0-.35,.03-.35,.5v1.78c0,.13,0,.28,.02,.39h-.14l-2.02-2.25v1.62c0,.35,.07,.46,.37,.46h.07v.12c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01v-.12h.06c.27,0,.36-.18,.36-.5v-1.65c0-.22-.18-.36-.36-.36h-.06v-.12c.14,0,.3,.01,.45,.01,.12,0,.23-.01,.35-.01l1.74,1.96h.02Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M15.43,23.72h-.16l-1.98-2.22v1.57c0,.35,.06,.43,.36,.45h.08v.16h-.02c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01h-.02v-.16h.07c.26,0,.33-.17,.33-.48v-1.65c0-.21-.17-.33-.33-.33h-.07v-.16h.02c.14,0,.3,.01,.45,.01,.11,0,.23-.01,.36,0l1.72,1.94v-1.44c0-.31-.21-.35-.32-.36h-.1v-.16h.02c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01h.02v.16h-.08c-.16,0-.32,.02-.33,.48v1.78c0,.13,0,.27,.02,.39v.02h-.01Zm-.14-.04h.12c-.01-.12-.02-.25-.02-.38v-1.78c0-.47,.2-.51,.37-.51h.04v-.08c-.16,0-.31,.01-.47,.01-.18,0-.36-.01-.53-.01v.08h.07c.12,0,.36,.06,.36,.39v1.48h-.02l-1.74-1.96c-.11,0-.23,.01-.35,.01-.14,0-.29-.01-.43-.01v.08h.03c.19,0,.37,.14,.37,.37v1.65c0,.31-.09,.51-.37,.51h-.03v.08c.17,0,.35-.01,.51-.01s.32,.01,.49,.01v-.08h-.04c-.31,0-.39-.13-.39-.48v-1.66l2.04,2.27v.02Zm-.08-.81h0Zm0,0h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M16.44,23.08c-.04,.13-.09,.23-.09,.3,0,.12,.17,.13,.29,.13h.04v.12c-.16,0-.31-.01-.48-.01-.14,0-.28,0-.42,.01v-.12h.02c.16,0,.28-.09,.33-.26l.62-1.79c.06-.14,.12-.35,.14-.49,.12-.04,.28-.12,.36-.17h.03s.02,0,.02,.01c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.11,.13,.16,.26,.16h.02v.12c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01v-.12h.04c.09,0,.25-.01,.25-.11,0-.06-.03-.16-.08-.28l-.16-.46h-.89l-.12,.41h.02Zm.57-1.75h0l-.37,1.1h.74l-.36-1.1h-.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M18.53,23.65c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01h-.02v-.16h.06c.09,0,.22-.02,.22-.1,0-.04-.03-.16-.08-.28l-.14-.45h-.87l-.12,.39c-.04,.13-.09,.23-.09,.3,0,.1,.14,.12,.28,.12h.06v.16h-.02c-.16,0-.31-.02-.47-.02-.14,0-.28,0-.42,.01h-.02v-.16h.04c.14,0,.27-.08,.32-.25l.62-1.79c.06-.14,.12-.35,.16-.5,.12-.04,.28-.12,.36-.17h.03s.03,0,.04,.02c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.1,.12,.14,.25,.14h.04v.16h0Zm-1.11-.02c.19,0,.38-.01,.57-.01s.36,0,.52,.01v-.08h0c-.13,0-.22-.06-.28-.17-.06-.12-.1-.27-.14-.4l-.72-2.05s-.02-.07-.03-.09h-.02c-.08,.04-.23,.12-.35,.16-.02,.14-.09,.35-.14,.49l-.62,1.79c-.06,.17-.2,.27-.36,.27h0v.08c.13,0,.27-.01,.4-.01,.16,0,.3,0,.46,.01v-.08h-.02c-.12,0-.3-.01-.31-.16,0-.08,.04-.18,.09-.31h0l.13-.42h.91l.16,.47c.04,.12,.08,.23,.08,.29,0,.12-.17,.13-.26,.13h-.02v.08h-.03Zm-.8-1.15l.38-1.15h.02v.02h0v-.02h.01l.37,1.15h-.78Zm.04-.03h.69l-.35-1.05s-.35,1.05-.35,1.05Zm.33-1.08h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M18.7,21.1c-.29,0-.3,.07-.37,.36h-.12c.01-.11,.03-.22,.04-.33,.01-.11,.02-.22,.02-.33h.09c.03,.12,.13,.11,.23,.11h2.02c.1,0,.2,0,.21-.12h.09c-.01,.12-.03,.22-.04,.33v.31l-.11,.04c0-.14-.02-.38-.29-.38h-.65v2.08c0,.3,.13,.33,.32,.33h.08v.12c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01v-.12h.08c.21,0,.32-.02,.32-.32v-2.09h-.63Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M20.24,23.65c-.16,0-.42-.01-.63-.01-.23,0-.51,.01-.66,.01h-.01v-.16h.09c.21,0,.3,0,.31-.31v-2.07h-.62v-.02h.66s0,2.09,0,2.09c0,.31-.12,.35-.35,.35h-.06v.08c.16,0,.41-.01,.65-.01,.2,0,.47,.01,.62,.01v-.08h-.06c-.19,0-.35-.04-.35-.36v-2.09h.66c.27,0,.3,.22,.3,.37l.09-.03v-.31c0-.1,.02-.2,.04-.3h-.06c-.02,.1-.13,.11-.22,.11h-2.04c-.09,0-.19,0-.22-.11h-.07c0,.11,0,.21-.02,.32,0,.11-.03,.21-.04,.31h.09c.06-.27,.09-.36,.38-.36h0v.03c-.29,0-.28,.06-.35,.35h-.01s-.13,.01-.13,.01v-.02c.02-.11,.03-.22,.04-.33,.01-.11,.02-.22,.02-.33v-.02h.12c.02,.11,.1,.11,.2,.11h2.04c.11,0,.19,0,.19-.11v-.02h.02l.11,.02v.02c-.02,.1-.03,.21-.04,.31v.31h0v.02s-.14,.06-.14,.06v-.02c0-.14-.02-.36-.28-.36h-.62v2.06c0,.3,.12,.31,.31,.32h.09v.16h-.06Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.09,23.52h.06c.14,0,.29-.02,.29-.22v-2.05c0-.2-.14-.22-.29-.22h-.06v-.12c.16,0,.39,.01,.58,.01s.43-.01,.61-.01v.12h-.06c-.14,0-.29,.02-.29,.22v2.05c0,.2,.14,.22,.29,.22h.06v.12c-.19,0-.42-.01-.62-.01s-.42,.01-.58,.01v-.12h.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.28,23.65c-.19,0-.42-.01-.62-.01s-.42,.01-.58,.01h-.01v-.13h.01s.06-.01,.06-.01c.14,0,.27-.01,.27-.21v-2.05c0-.19-.13-.2-.27-.21h-.07v-.16h.01c.16,0,.39,.01,.58,.01s.43-.01,.61-.01h.01v.16h-.07c-.14,0-.27,.01-.28,.21v2.05c0,.19,.13,.2,.28,.21h.07v.16h0Zm-.02-.04v-.08h-.03c-.14,0-.31-.02-.31-.25v-2.05c0-.21,.17-.25,.31-.25h.03v-.08c-.18,0-.4,.01-.6,.01s-.41-.01-.56-.01v.08h.03c.13,0,.31,.02,.31,.25v2.05c0,.21-.17,.25-.31,.25h-.03v.08c.16,0,.37-.01,.56-.01s.41,.01,.6,.01",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M23.84,20.84c.84,0,1.5,.51,1.5,1.35,0,.9-.65,1.5-1.48,1.5s-1.46-.57-1.46-1.4,.63-1.45,1.45-1.45m.06,2.67c.76,0,.89-.67,.89-1.24s-.31-1.27-.96-1.27c-.68,0-.89,.61-.89,1.14,0,.7,.32,1.37,.96,1.37",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.38,22.29c0-.82,.63-1.46,1.46-1.46v.03c-.8,0-1.43,.62-1.43,1.43s.62,1.39,1.45,1.39,1.46-.59,1.46-1.48c0-.82-.66-1.34-1.48-1.34v-.03c.84,0,1.52,.52,1.52,1.37,0,.91-.66,1.52-1.49,1.52s-1.48-.57-1.48-1.43m.55-.13c0-.52,.21-1.15,.9-1.15s.98,.7,.98,1.28-.13,1.26-.91,1.26h0v-.03c.75,0,.87-.66,.88-1.23,0-.57-.3-1.25-.95-1.25s-.87,.6-.87,1.11c0,.7,.32,1.35,.94,1.36v.02h0c-.65,.01-.97-.67-.97-1.37",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.98,22.87h0v-1.47c0-.32-.22-.37-.35-.37h-.09v-.12c.18,0,.37,.01,.55,.01,.17,0,.32-.01,.48-.01v.12h-.06c-.17,0-.35,.03-.35,.5v1.78c0,.13,0,.28,.02,.39h-.14l-2.02-2.25v1.62c0,.35,.07,.46,.37,.46h.07v.12c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01v-.12h.06c.27,0,.36-.18,.36-.5v-1.65c0-.22-.18-.36-.36-.36h-.06v-.12c.14,0,.3,.01,.45,.01,.12,0,.23-.01,.35-.01l1.74,1.96h.02Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.21,23.72h-.17l-1.98-2.22v1.57c0,.35,.06,.43,.35,.45h.09v.16h-.02c-.17,0-.33-.01-.5-.01s-.36,.01-.53,.01h-.01v-.16h.07c.26,0,.33-.17,.33-.48v-1.65c0-.21-.17-.33-.33-.33h-.07v-.16h.01c.14,0,.3,.01,.45,.01,.11,0,.23-.01,.36,0l1.72,1.94v-1.44c0-.31-.21-.35-.32-.36h-.1v-.16h.02c.19,0,.37,.01,.55,.01,.16,0,.32-.01,.48-.01h.02v.16h-.08c-.16,0-.32,.02-.33,.48v1.78c0,.13,0,.27,.02,.39v.02h0Zm-.14-.04h.13c-.02-.12-.02-.25-.02-.38v-1.78c0-.47,.2-.51,.37-.51h.04v-.08c-.16,0-.31,.01-.47,.01-.18,0-.36-.01-.53-.01v.08h.07c.12,0,.36,.06,.36,.39v1.48h-.02l-1.74-1.96c-.11,0-.23,.01-.35,.01-.14,0-.29-.01-.43-.01v.08h.03c.19,0,.38,.14,.38,.37v1.65c0,.31-.09,.51-.37,.51h-.03v.08c.17,0,.35-.01,.51-.01s.32,.01,.49,.01v-.08h-.06c-.31,0-.38-.13-.38-.48v-1.66l2.03,2.27v.02Zm-.09-.81h0Zm0,0h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.22,23.08c-.03,.13-.09,.23-.09,.3,0,.12,.17,.13,.29,.13h.04v.12c-.16,0-.31-.01-.48-.01-.14,0-.28,0-.42,.01v-.12h.02c.16,0,.28-.09,.35-.26l.62-1.79c.06-.14,.12-.35,.14-.49,.12-.04,.28-.12,.36-.17h.03s.02,0,.02,.01c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.11,.13,.16,.26,.16h.02v.12c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01v-.12h.04c.09,0,.25-.01,.25-.11,0-.06-.03-.16-.08-.28l-.16-.46h-.89l-.12,.41h.01Zm.57-1.75h0l-.37,1.1h.74l-.36-1.1h-.01Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.3,23.65c-.18,0-.36-.01-.53-.01s-.39,0-.59,.01h-.02v-.16h.06c.09,0,.22-.02,.22-.1,0-.04-.03-.16-.08-.28l-.14-.45h-.87l-.12,.39c-.04,.13-.09,.23-.09,.3,0,.1,.14,.12,.28,.12h.06v.16h-.02c-.16,0-.31-.02-.47-.02-.14,0-.28,0-.42,.01h-.02v-.16h.04c.14,0,.27-.09,.32-.25l.62-1.79c.04-.14,.12-.35,.16-.5,.12-.04,.28-.12,.36-.17h.03s.03,0,.04,.02c.01,.03,.02,.07,.03,.1l.72,2.05c.04,.13,.09,.28,.14,.4,.04,.1,.11,.14,.25,.14h.04v.16h0Zm-1.11-.02c.19,0,.38-.01,.57-.01s.36,0,.52,.01v-.08h0c-.13,0-.22-.06-.28-.17-.06-.12-.1-.27-.14-.4l-.72-2.05s-.02-.07-.03-.09t0,0h-.02c-.08,.04-.23,.12-.35,.16-.02,.14-.09,.35-.14,.49l-.62,1.79c-.06,.17-.2,.27-.36,.27h0v.08c.13,0,.27-.01,.41-.01,.16,0,.3,0,.46,.01v-.08h-.02c-.12,0-.3-.01-.31-.16,0-.08,.04-.18,.09-.31h0l.13-.42h.91l.16,.47c.04,.12,.08,.23,.08,.29,0,.12-.17,.13-.26,.13h-.02v.08h-.04Zm-.8-1.15l.38-1.14h.02v.02h0v-.02h.01l.37,1.14h-.78Zm.04-.03h.69l-.35-1.05s-.35,1.05-.35,1.05Zm.33-1.08h0Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.3,23.26c0,.16,.11,.2,.23,.22,.16,.01,.33,.01,.51,0,.17-.02,.3-.11,.38-.21,.07-.09,.1-.2,.12-.28h.11c-.04,.22-.1,.45-.14,.67-.35,0-.69-.01-1.04-.01s-.69,.01-1.04,.01v-.12h.06c.14,0,.29-.02,.29-.27v-2.02c0-.2-.16-.22-.29-.22h-.06v-.12c.21,0,.41,.01,.61,.01s.4-.01,.59-.01v.12h-.1c-.14,0-.27,0-.27,.21v2.02h.02Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M33.51,23.65c-.35,0-.69-.01-1.04-.01s-.69,.01-1.04,.01h-.01v-.16h.07c.14,0,.28-.01,.28-.25v-2.02c0-.19-.13-.2-.28-.21h-.07v-.16h.01c.21,0,.41,.01,.62,.01s.39-.01,.59-.01h.01v.16h-.11c-.16,0-.25,0-.25,.2v2.02c0,.14,.1,.19,.22,.2h.21c.1,0,.19,0,.3-.01,.16-.02,.3-.11,.37-.2,.06-.09,.09-.19,.12-.28h.01s.13-.01,.13-.01v.02c-.04,.22-.1,.45-.14,.67h-.01s-.01,.02-.01,.02Zm-.01-.03c.04-.21,.1-.42,.13-.63h-.08c-.02,.09-.06,.19-.12,.28-.08,.1-.22,.2-.39,.22-.1,.01-.2,.01-.3,.01h-.22c-.12-.01-.25-.07-.25-.23v-2.02c0-.22,.13-.23,.28-.23h.08v-.08c-.19,0-.38,.01-.58,.01s-.4-.01-.6-.01v.08h.03c.14,0,.31,.02,.31,.25v2.02c0,.26-.17,.28-.31,.28h-.03v.08c.33,0,.68-.01,1.01-.01s.68,.01,1.01,.01",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M33.61,20.8c.23,0,.41,.18,.41,.41s-.18,.41-.41,.41-.41-.18-.41-.41,.18-.41,.41-.41m0,.75c.19,0,.32-.16,.32-.33s-.13-.33-.32-.33-.32,.16-.32,.33,.14,.33,.32,.33m-.2-.11v-.02s.06,0,.06-.03v-.3s0-.06-.06-.06v-.02h.21c.07,0,.13,.03,.13,.11,0,.07-.04,.11-.1,.12l.07,.1s.07,.08,.09,.1h-.08s-.07-.07-.14-.18h-.04v.13s0,.02,.06,.03v.02h-.19Zm.14-.23h.04s.08-.04,.08-.1-.04-.09-.08-.09h-.04v.19Z",
						fill: "#fff"
					},
					children: [
					]
				}
			]
		},
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M9.17,6.98C9.17,3.32,12.14,.36,15.8,.36s6.63,2.96,6.63,6.63-2.96,6.63-6.63,6.63-6.63-2.96-6.63-6.63",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M15.81,13.74c-3.8,.02-6.93-3.06-6.93-6.81C8.88,2.83,12.01,0,15.81,0h1.78c3.75,0,7.19,2.83,7.19,6.93,0,3.74-3.43,6.81-7.19,6.81h-1.78Zm.01-13.17c-3.48,0-6.28,2.82-6.28,6.28s2.82,6.28,6.28,6.28,6.28-2.82,6.28-6.28S19.28,.57,15.82,.57m-1.43,10V3.14c-1.49,.58-2.55,2.02-2.56,3.72,0,1.69,1.06,3.14,2.56,3.72m5.41-3.72c0-1.69-1.07-3.14-2.56-3.72v7.44c1.49-.58,2.55-2.02,2.56-3.72",
						fill: "#0069aa"
					},
					children: [
					]
				}
			]
		}
	]
},
	dinersClub: dinersClub,
	"discover-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		viewBox: "0 0 34 21.74"
	},
	children: [
		{
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "linearGradient",
					type: "element",
					value: "",
					attributes: {
						id: "linear-gradient",
						x1: "-.05",
						y1: "-.1",
						x2: ".95",
						y2: "-.1",
						gradientTransform: "translate(17.72 12.83) rotate(-122.57) scale(3.15 -3.15)",
						gradientUnits: "userSpaceOnUse"
					},
					children: [
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: "0",
								"stop-color": "#ff9200"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".21",
								"stop-color": "#ff8d00"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".45",
								"stop-color": "#ff7f00"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".62",
								"stop-color": "#ff7100"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: ".83",
								"stop-color": "#ff5d00"
							},
							children: [
							]
						},
						{
							name: "stop",
							type: "element",
							value: "",
							attributes: {
								offset: "1",
								"stop-color": "#ff5200"
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			name: "image",
			type: "element",
			value: "",
			attributes: {
				width: "35",
				height: "20",
				transform: "translate(14.54 10.98) scale(.14 -.14)",
				"xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAOCAYAAAChHnWMAAAACXBIWXMAAE9aAABPWgHOoUeGAAAAzUlEQVQ4jcWUCwrEIBBDx8+d9rB713Fp0RJjdFu6bIUwxU/zyIihvKwYjlDVRhB1U4Q6U7J5rWvhbSHvCGhaqppZjzju2aqDWSFF07WdMbPcmTAMzq9gIn2jkoDw3fn4Zx4MEUbNKxiHNaVIEAjWJaEMzsIUukszGE4kYRJodBeG24P950RcJfErGCco1aqI7VBJYMQz0xVMO+uUjNOFvZTEXZhWuU2nkljBnIVkGAY5klDvwzeYq4mV+b7+nfgHDF7aoR1PwKiH75FhZh/9cY0ue4uTswAAAABJRU5ErkJggg=="
			},
			children: [
			]
		},
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.12,.37c-.1,0-.2,.02-.29,.06-.25,.11-.42,.35-.44,.63,0,.02-.01,.04-.01,.06V20.62c0,.08,.02,.14,.04,.21,.03,.11,.08,.2,.16,.29,.07,.08,.16,.15,.26,.19,.01,0,.03,0,.05,0,.08,.03,.16,.05,.24,.05H21.83c.14,0,.28-.02,.42-.02,.24,0,.49-.02,.73-.04,.3-.03,.59-.08,.88-.13,.4-.08,.79-.18,1.17-.3,1.43-.46,2.71-1.22,3.8-2.2,.31-.28,.6-.57,.87-.88,.2-.22,.38-.46,.56-.7,.15-.2,.29-.41,.43-.62,.12-.19,.24-.38,.35-.58,.09-.17,.17-.35,.25-.52,.08-.17,.16-.34,.24-.51,.06-.16,.12-.32,.17-.48,.06-.16,.12-.31,.16-.47,.04-.14,.08-.29,.11-.44,.04-.15,.08-.29,.11-.44,.03-.14,.05-.28,.07-.41,.02-.14,.05-.27,.06-.41,.02-.13,.04-.27,.05-.4,.01-.13,.01-.26,.02-.39s.02-.26,.02-.39c0-.06,0-.11,0-.17,0-.07,0-.14-.01-.21,0-.12-.01-.24-.02-.36s0-.24-.02-.36c-.01-.12-.03-.23-.04-.35-.01-.12-.03-.23-.05-.34-.02-.11-.03-.23-.05-.34-.02-.11-.05-.22-.07-.33-.02-.11-.06-.22-.08-.33-.03-.11-.05-.22-.08-.33-.03-.11-.06-.21-.1-.32-.03-.1-.08-.21-.11-.31-.04-.1-.07-.21-.11-.31-.04-.1-.08-.2-.12-.3-.04-.1-.09-.2-.14-.29-.05-.1-.09-.2-.14-.29-.05-.1-.1-.19-.15-.29-.05-.09-.11-.18-.17-.28s-.11-.19-.17-.28c-.06-.09-.11-.19-.17-.28-.06-.09-.13-.17-.2-.26-.06-.09-.13-.18-.2-.26-.07-.09-.13-.18-.2-.26-.07-.09-.15-.16-.22-.25s-.15-.17-.22-.25c-.08-.08-.15-.17-.22-.25-.08-.08-.17-.15-.25-.23-.08-.08-.17-.15-.25-.23-.09-.08-.17-.16-.25-.23-.09-.07-.19-.14-.28-.21-.09-.07-.19-.14-.28-.21-.1-.07-.19-.14-.29-.21-.1-.07-.21-.13-.32-.19-.11-.06-.21-.13-.32-.19-.11-.06-.22-.12-.33-.18-.12-.06-.24-.11-.35-.17s-.23-.12-.35-.17c-.13-.05-.26-.1-.39-.15-.35-.13-.71-.25-1.08-.34-.41-.11-.83-.19-1.25-.25-.46-.06-.93-.1-1.4-.1H1.12Zm15.7,12.89c-1.35,0-2.45-1.1-2.45-2.45s1.1-2.45,2.45-2.45,2.45,1.1,2.45,2.45-1.1,2.45-2.45,2.45Zm14.1-4.43c0,.2-.16,.36-.35,.36s-.35-.16-.35-.36,.16-.36,.35-.36,.35,.16,.35,.36Zm-2.57-.32c1.04,0,1.64,.5,1.64,1.36,0,.71-.37,1.17-1.05,1.31l1.45,1.95h-1.11l-1.25-1.86h-.12v1.86h-.9v-4.62h1.34Zm-1.93,0v.78h-1.66v1.03h1.59v.78h-1.59v1.25h1.66v.78h-2.56v-4.62h2.56Zm-6.42,0l1.23,3.1,1.25-3.1h.98l-2,4.74h-.49l-1.96-4.74h.98Zm-7.02-.1c.39,0,.71,.08,1.11,.28v1.06c-.37-.37-.7-.52-1.13-.52-.85,0-1.51,.7-1.51,1.59,0,.94,.64,1.59,1.55,1.59,.41,0,.73-.15,1.09-.51v1.06c-.41,.19-.74,.27-1.13,.27-1.37,0-2.44-1.05-2.44-2.41s1.09-2.42,2.46-2.42Zm-2.9,.54l-.47,.62c-.23-.26-.46-.37-.73-.37-.39,0-.67,.22-.67,.51,0,.25,.16,.38,.7,.58,1.03,.38,1.33,.71,1.33,1.44,0,.89-.66,1.52-1.59,1.52-.69,0-1.18-.27-1.6-.88l.58-.56c.21,.4,.55,.62,.98,.62,.4,0,.7-.28,.7-.65,0-.19-.09-.36-.27-.48-.09-.06-.27-.14-.62-.26-.85-.3-1.14-.63-1.14-1.27,0-.76,.62-1.32,1.44-1.32,.51,0,.97,.17,1.36,.51Zm-3.37-.44v4.62h-.9v-4.62h.9Zm-3.8,0c1.46,0,2.48,.95,2.48,2.31,0,.68-.31,1.34-.84,1.77-.44,.37-.95,.53-1.65,.53H1.57v-4.62h1.32Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.91,9.24v1.4h.26c.58,0,.88-.25,.88-.71s-.31-.68-.87-.68h-.28Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M2.47,12.35h.24c.58,0,.95-.11,1.23-.37,.31-.28,.5-.72,.5-1.16s-.19-.87-.5-1.15c-.3-.27-.65-.37-1.23-.37h-.24v3.06Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "30.51 8.81 30.53 8.81 30.6 8.76 30.53 8.7 30.51 8.7 30.51 8.81",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.28,8.83c0,.16,.13,.29,.28,.29s.28-.13,.28-.29-.13-.29-.28-.29-.28,.13-.28,.29Zm.42-.08l-.09,.11,.13,.17h-.12l-.11-.16v.16h-.1v-.41h.13c.1,0,.15,.04,.15,.13Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.57,13.13h1.32c.7,0,1.21-.16,1.65-.53,.53-.44,.84-1.09,.84-1.77,0-1.36-1.02-2.31-2.48-2.31H1.57v4.62Zm2.38-3.46c.31,.28,.5,.71,.5,1.15s-.19,.89-.5,1.16c-.28,.26-.65,.37-1.23,.37h-.24v-3.06h.24c.58,0,.94,.1,1.23,.37Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						x: "5.79",
						y: "8.51",
						width: ".9",
						height: "4.62",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M7.27,9.76c0,.64,.29,.96,1.14,1.27,.35,.12,.53,.21,.62,.26,.18,.12,.27,.28,.27,.48,0,.37-.3,.65-.7,.65-.43,0-.78-.21-.98-.62l-.58,.56c.42,.61,.91,.88,1.6,.88,.94,0,1.59-.62,1.59-1.52,0-.73-.3-1.07-1.33-1.44-.54-.2-.7-.33-.7-.58,0-.29,.28-.51,.67-.51,.27,0,.49,.11,.73,.37l.47-.62c-.39-.34-.85-.51-1.36-.51-.82,0-1.44,.57-1.44,1.32Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M10.51,10.83c0,1.36,1.07,2.41,2.44,2.41,.39,0,.72-.08,1.13-.27v-1.06c-.36,.36-.68,.51-1.09,.51-.91,0-1.55-.66-1.55-1.59,0-.89,.66-1.59,1.51-1.59,.43,0,.76,.15,1.13,.52v-1.06c-.4-.2-.72-.28-1.11-.28-1.37,0-2.46,1.07-2.46,2.42Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "19.01 8.51 20.97 13.25 21.45 13.25 23.45 8.51 22.47 8.51 21.23 11.62 19.99 8.51 19.01 8.51",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "23.86 13.13 26.41 13.13 26.41 12.35 24.76 12.35 24.76 11.1 26.35 11.1 26.35 10.32 24.76 10.32 24.76 9.3 26.41 9.3 26.41 8.51 23.86 8.51 23.86 13.13",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.01,13.13h.9v-1.86h.12l1.25,1.86h1.11l-1.45-1.95c.68-.14,1.05-.6,1.05-1.31,0-.86-.6-1.36-1.64-1.36h-1.34v4.62Zm2.04-3.21c0,.46-.31,.71-.88,.71h-.26v-1.4h.28c.56,0,.87,.24,.87,.68Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.42,8.63v.41h.1v-.16l.11,.16h.12l-.13-.17,.09-.11c0-.08-.06-.13-.15-.13h-.13Zm.11,.07l.07,.05-.07,.05h-.02v-.11h.02Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.21,8.83c0,.2,.16,.36,.35,.36s.35-.16,.35-.36-.16-.36-.35-.36-.35,.16-.35,.36Zm.63,0c0,.16-.13,.29-.28,.29s-.28-.13-.28-.29,.13-.29,.28-.29,.28,.13,.28,.29Z",
						fill: "#261f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M19.26,10.82c0-1.35-1.1-2.45-2.45-2.45s-2.45,1.1-2.45,2.45,1.1,2.45,2.45,2.45,2.45-1.1,2.45-2.45Z",
						fill: "#fff"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M19.26,10.82c0-1.35-1.1-2.45-2.45-2.45s-2.45,1.1-2.45,2.45,1.1,2.45,2.45,2.45,2.45-1.1,2.45-2.45Z",
						fill: "url(#linear-gradient)"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.83,.43c.09-.04,.19-.06,.29-.06h.46l.65-.37H1.12C.5,0,0,.5,0,1.12v.16l.38-.22c.02-.28,.19-.52,.44-.63Z",
						fill: "#e15115"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.37,1.12s.01-.04,.01-.06l-.38,.22v.97l.37-.22v-.92Z",
						fill: "#e25215"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "3.26 .37 3.9 0 2.22 0 1.58 .37 3.26 .37",
						fill: "#e25215"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "3.26 .37 4.94 .37 5.58 0 3.9 0 3.26 .37",
						fill: "#e25316"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 2.04 0 2.25 0 3.22 .37 3.01 .37 2.04",
						fill: "#e25316"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "6.62 .37 7.26 0 5.58 0 4.94 .37 6.62 .37",
						fill: "#e35416"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 3.01 0 3.22 0 4.19 .37 3.98 .37 3.01",
						fill: "#e35416"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "8.3 .37 8.94 0 7.26 0 6.62 .37 8.3 .37",
						fill: "#e35516"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 3.98 0 4.19 0 5.16 .37 4.95 .37 3.98",
						fill: "#e35516"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "9.98 .37 10.62 0 8.94 0 8.3 .37 9.98 .37",
						fill: "#e35616"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 4.95 0 5.16 0 6.13 .37 5.92 .37 4.95",
						fill: "#e35616"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 5.92 0 6.13 0 7.1 .37 6.89 .37 5.92",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "11.65 .37 12.3 0 10.62 0 9.98 .37 11.65 .37",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 6.89 0 7.1 0 8.07 .37 7.86 .37 6.89",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "13.33 .37 13.98 0 12.3 0 11.65 .37 13.33 .37",
						fill: "#e45716"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "15.01 .37 15.66 0 13.98 0 13.33 .37 15.01 .37",
						fill: "#e55816"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 7.86 0 8.07 0 9.04 .37 8.83 .37 7.86",
						fill: "#e55816"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "16.69 .37 17.34 0 15.66 0 15.01 .37 16.69 .37",
						fill: "#e55916"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 8.83 0 9.04 0 10.01 .37 9.8 .37 8.83",
						fill: "#e55916"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 9.8 0 10.01 0 10.98 .37 10.77 .37 9.8",
						fill: "#e55a16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "18.37 .37 19.02 0 17.34 0 16.69 .37 18.37 .37",
						fill: "#e55a16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 10.77 0 10.98 0 11.95 .37 11.73 .37 10.77",
						fill: "#e65b16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "20.05 .37 20.7 0 19.02 0 18.37 .37 20.05 .37",
						fill: "#e65b16"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 11.73 0 11.95 0 12.92 .37 12.7 .37 11.73",
						fill: "#e65c17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "21.73 .37 22.38 0 20.7 0 20.05 .37 21.73 .37",
						fill: "#e65c17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.83,.37c.48,0,.94,.04,1.4,.1l.83-.48h-1.68l-.65,.37h.1Z",
						fill: "#e75d17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 12.7 0 12.92 0 13.89 .37 13.67 .37 12.7",
						fill: "#e75d17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.48,.72l1.26-.72h-1.68l-.83,.48c.43,.06,.84,.14,1.25,.25Z",
						fill: "#e75e17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 13.67 0 13.89 0 14.86 .37 14.64 .37 13.67",
						fill: "#e75e17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.56,1.07l1.85-1.07h-1.68l-1.26,.72c.37,.1,.73,.21,1.08,.34Z",
						fill: "#e85f17"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 14.64 0 14.86 0 15.83 .37 15.61 .37 14.64",
						fill: "#e85f17"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.96,1.22l2.11-1.22h-.65l-1.85,1.07c.13,.05,.26,.09,.39,.15Z",
						fill: "#e86017"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 15.61 0 15.83 0 16.2 .37 15.99 .37 15.61",
						fill: "#e86017"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M26.31,1.39l2.41-1.39h-.65l-2.11,1.22c.12,.05,.24,.11,.35,.17Z",
						fill: "#e86117"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 15.99 0 16.2 0 16.58 .37 16.36 .37 15.99",
						fill: "#e86117"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 16.36 0 16.58 0 16.95 .37 16.74 .37 16.36",
						fill: "#e96217"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M26.66,1.56l2.7-1.56h-.65l-2.41,1.39c.12,.06,.24,.11,.35,.17Z",
						fill: "#e96217"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27,1.74l3.02-1.74h-.65l-2.7,1.56c.11,.06,.22,.12,.33,.18Z",
						fill: "#e96317"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 16.74 0 16.95 0 17.33 .37 17.11 .37 16.74",
						fill: "#e96317"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.31,1.93l3.35-1.93h-.65l-3.02,1.74c.11,.06,.21,.13,.32,.19Z",
						fill: "#e96418"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 17.11 0 17.33 0 17.7 .37 17.49 .37 17.11",
						fill: "#e96418"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.63,2.13l3.68-2.13h-.65l-3.35,1.93c.11,.06,.21,.12,.32,.19Z",
						fill: "#e96518"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 17.49 0 17.7 0 18.08 .37 17.86 .37 17.49",
						fill: "#e96518"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.92,2.33L31.96,0h-.65l-3.68,2.13c.1,.07,.19,.14,.29,.21Z",
						fill: "#ea6618"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 17.86 0 18.08 0 18.45 .37 18.24 .37 17.86",
						fill: "#ea6618"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.2,2.54l4.41-2.54h-.65l-4.04,2.33c.1,.07,.19,.14,.28,.21Z",
						fill: "#ea6718"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 18.24 0 18.45 0 18.83 .37 18.61 .37 18.24",
						fill: "#ea6718"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.49,2.76L33.16,.06c-.09-.02-.18-.06-.28-.06h-.27l-4.41,2.54c.09,.07,.19,.14,.28,.21Z",
						fill: "#ea6818"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 18.61 0 18.83 0 19.2 .37 18.99 .37 18.61",
						fill: "#ea6818"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 18.99 0 19.2 0 19.58 .37 19.36 .37 18.99",
						fill: "#ea6918"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.74,2.98L33.52,.23c-.11-.08-.23-.13-.36-.17l-4.67,2.7c.09,.07,.17,.15,.25,.23Z",
						fill: "#ea6918"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 19.36 0 19.58 0 19.95 .37 19.74 .37 19.36",
						fill: "#eb6a18"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.99,3.21L33.76,.46c-.07-.09-.15-.17-.24-.24l-4.78,2.76c.09,.07,.17,.15,.25,.23Z",
						fill: "#eb6a18"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: ".37 19.74 0 19.95 0 20.33 .37 20.11 .37 19.74",
						fill: "#eb6b19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.25,3.44l4.68-2.7c-.04-.1-.1-.19-.16-.28l-4.77,2.75c.08,.08,.17,.15,.25,.23Z",
						fill: "#eb6b19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.47,3.69l4.52-2.61c0-.12-.03-.23-.07-.34l-4.68,2.7c.08,.08,.15,.16,.22,.25Z",
						fill: "#eb6c19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.37,20.11l-.37,.22v.3s.01,.05,.01,.07l.36-.21v-.37Z",
						fill: "#eb6c19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.37,20.62v-.14l-.36,.21c0,.12,.03,.23,.07,.34l.33-.19c-.02-.07-.04-.14-.04-.21Z",
						fill: "#eb6d19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.69,3.93l4.31-2.49v-.33s0-.03,0-.04l-4.52,2.61c.08,.08,.15,.16,.22,.25Z",
						fill: "#eb6d19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.92,4.18l4.08-2.36v-.37l-4.31,2.49c.07,.08,.15,.16,.22,.25Z",
						fill: "#ec6e19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.42,20.84l-.33,.19c.04,.1,.1,.19,.17,.28l.32-.18c-.07-.08-.12-.18-.16-.29Z",
						fill: "#ec6e19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.11,4.44l3.89-2.24v-.37l-4.08,2.36c.07,.08,.13,.17,.2,.26Z",
						fill: "#ec6f19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.88,21.32s-.03,0-.05,0c-.1-.04-.19-.11-.26-.19l-.32,.18c.07,.09,.16,.16,.25,.23l.37-.21Z",
						fill: "#ec6f19"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.31,4.7l3.69-2.13v-.37l-3.89,2.24c.07,.09,.13,.17,.2,.26Z",
						fill: "#ec7019"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.12,21.37c-.09,0-.17-.02-.24-.05l-.37,.21c.11,.08,.24,.13,.37,.16l.56-.32h-.32Z",
						fill: "#ec7019"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.51,4.96l3.49-2.02v-.37l-3.69,2.13c.06,.09,.13,.17,.2,.26Z",
						fill: "#ec7119"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.44,21.37l-.56,.32c.08,.02,.16,.05,.24,.05h.32l.65-.37h-.65Z",
						fill: "#ec7119"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.68,5.24l3.32-1.92v-.37l-3.49,2.02c.06,.09,.11,.18,.17,.28Z",
						fill: "#ed7219"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "2.09 21.37 1.44 21.74 2.09 21.74 2.74 21.37 2.09 21.37",
						fill: "#ed7219"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "2.74 21.37 2.09 21.74 2.74 21.74 3.39 21.37 2.74 21.37",
						fill: "#ed731a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.85,5.52l3.15-1.82v-.37l-3.32,1.92c.06,.09,.11,.18,.17,.28Z",
						fill: "#ed731a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "3.39 21.37 2.74 21.74 3.39 21.74 4.04 21.37 3.39 21.37",
						fill: "#ed741a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.02,5.79l2.98-1.72v-.37l-3.15,1.82c.06,.09,.12,.18,.17,.28Z",
						fill: "#ed741a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.16,6.08l2.84-1.64v-.37l-2.98,1.72c.05,.09,.1,.19,.15,.29Z",
						fill: "#ed751a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "4.04 21.37 3.39 21.74 4.04 21.74 4.69 21.37 4.04 21.37",
						fill: "#ed751a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.31,6.38l2.69-1.56v-.37l-2.84,1.64c.05,.1,.09,.2,.14,.29Z",
						fill: "#ee761a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "4.69 21.37 4.04 21.74 4.69 21.74 5.33 21.37 4.69 21.37",
						fill: "#ee761a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "5.33 21.37 4.69 21.74 5.34 21.74 5.98 21.37 5.33 21.37",
						fill: "#ee771a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.45,6.67l2.55-1.47v-.37l-2.69,1.56c.05,.1,.1,.19,.14,.29Z",
						fill: "#ee771a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.57,6.97l2.43-1.4v-.37l-2.55,1.47c.04,.1,.08,.2,.12,.3Z",
						fill: "#ee781a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "5.98 21.37 5.34 21.74 5.99 21.74 6.63 21.37 5.98 21.37",
						fill: "#ee781a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "6.63 21.37 5.99 21.74 6.64 21.74 7.28 21.37 6.63 21.37",
						fill: "#ef791a"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.68,7.28l2.32-1.34v-.37l-2.43,1.4c.04,.1,.08,.21,.11,.31Z",
						fill: "#ef791a"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "7.28 21.37 6.64 21.74 7.29 21.74 7.93 21.37 7.28 21.37",
						fill: "#ef7a1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.8,7.59l2.2-1.27v-.37l-2.32,1.34c.04,.1,.08,.2,.11,.31Z",
						fill: "#ef7a1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.9,7.91l2.1-1.21v-.37l-2.2,1.27c.03,.11,.07,.21,.1,.32Z",
						fill: "#ef7b1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "7.93 21.37 7.29 21.74 7.93 21.74 8.58 21.37 7.93 21.37",
						fill: "#ef7b1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.98,8.24l2.02-1.17v-.37l-2.1,1.21c.03,.11,.06,.22,.08,.33Z",
						fill: "#ef7c1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "8.58 21.37 7.93 21.74 8.58 21.74 9.23 21.37 8.58 21.37",
						fill: "#ef7c1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.06,8.56l1.94-1.12v-.37l-2.02,1.17c.03,.11,.06,.22,.08,.33Z",
						fill: "#f07d1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "9.23 21.37 8.58 21.74 9.23 21.74 9.88 21.37 9.23 21.37",
						fill: "#f07d1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "9.88 21.37 9.23 21.74 9.88 21.74 10.53 21.37 9.88 21.37",
						fill: "#f07e1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.14,8.9l1.86-1.08v-.37l-1.94,1.12c.02,.11,.05,.22,.07,.33Z",
						fill: "#f07e1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.19,9.24l1.81-1.05v-.37l-1.86,1.08c.02,.11,.03,.23,.05,.34Z",
						fill: "#f07f1b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "10.53 21.37 9.88 21.74 10.53 21.74 11.18 21.37 10.53 21.37",
						fill: "#f07f1b"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.24,9.59l1.76-1.02v-.37l-1.81,1.05c.02,.11,.04,.23,.05,.34Z",
						fill: "#f0801b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "11.18 21.37 10.53 21.74 11.18 21.74 11.83 21.37 11.18 21.37",
						fill: "#f0801b"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "11.83 21.37 11.18 21.74 11.83 21.74 12.48 21.37 11.83 21.37",
						fill: "#f1801c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.28,9.94l1.72-.99v-.37l-1.76,1.02c.01,.12,.03,.23,.04,.35Z",
						fill: "#f1801c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.3,10.3l1.7-.98v-.37l-1.72,.99c.01,.12,.01,.24,.02,.36Z",
						fill: "#f1811c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "12.48 21.37 11.83 21.74 12.48 21.74 13.13 21.37 12.48 21.37",
						fill: "#f1811c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.32,10.67l1.68-.97v-.37l-1.7,.98c0,.12,.02,.24,.02,.36Z",
						fill: "#f1821c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "13.13 21.37 12.48 21.74 13.13 21.74 13.78 21.37 13.13 21.37",
						fill: "#f1821c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "13.78 21.37 13.13 21.74 13.78 21.74 14.42 21.37 13.78 21.37",
						fill: "#f1831c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.33,10.87c0,.06,0,.11,0,.17l1.68-.97v-.37l-1.68,.97c0,.07,.01,.14,.01,.21Z",
						fill: "#f1831c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "14.42 21.37 13.78 21.74 14.43 21.74 15.07 21.37 14.42 21.37",
						fill: "#f2841c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.3,11.43l1.7-.98v-.37l-1.68,.97c0,.13-.01,.26-.02,.39Z",
						fill: "#f2841c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.28,11.81l1.72-.99v-.37l-1.7,.98c0,.13,0,.26-.02,.39Z",
						fill: "#f2851c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "15.07 21.37 14.43 21.74 15.08 21.74 15.72 21.37 15.07 21.37",
						fill: "#f2851c"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.23,12.21l1.77-1.02v-.37l-1.72,.99c-.01,.14-.03,.27-.05,.4Z",
						fill: "#f2861c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "15.72 21.37 15.08 21.74 15.73 21.74 16.37 21.37 15.72 21.37",
						fill: "#f2861c"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "16.37 21.37 15.73 21.74 16.38 21.74 17.02 21.37 16.37 21.37",
						fill: "#f2871d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.17,12.63l1.83-1.06v-.37l-1.77,1.02c-.02,.14-.04,.27-.06,.41Z",
						fill: "#f2871d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.1,13.04l1.9-1.1v-.37l-1.83,1.06c-.02,.14-.04,.28-.07,.41Z",
						fill: "#f3881d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "17.02 21.37 16.38 21.74 17.02 21.74 17.67 21.37 17.02 21.37",
						fill: "#f3881d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.99,13.48l2.01-1.16v-.37l-1.9,1.1c-.03,.15-.08,.29-.11,.44Z",
						fill: "#f3891d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "17.67 21.37 17.02 21.74 17.67 21.74 18.32 21.37 17.67 21.37",
						fill: "#f3891d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.87,13.92l2.13-1.23v-.37l-2.01,1.16c-.04,.15-.07,.3-.11,.44Z",
						fill: "#f38a1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "18.32 21.37 17.67 21.74 18.32 21.74 18.97 21.37 18.32 21.37",
						fill: "#f38a1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "18.97 21.37 18.32 21.74 18.97 21.74 19.62 21.37 18.97 21.37",
						fill: "#f48b1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.71,14.39l2.29-1.32v-.37l-2.13,1.23c-.05,.16-.11,.31-.16,.47Z",
						fill: "#f48b1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.54,14.87l2.46-1.42v-.37l-2.29,1.32c-.06,.16-.11,.32-.17,.48Z",
						fill: "#f48c1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "19.62 21.37 18.97 21.74 19.62 21.74 20.27 21.37 19.62 21.37",
						fill: "#f48c1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.3,15.38l2.7-1.56v-.37l-2.46,1.42c-.07,.17-.15,.34-.24,.51Z",
						fill: "#f48d1d"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "20.27 21.37 19.62 21.74 20.27 21.74 20.92 21.37 20.27 21.37",
						fill: "#f48d1d"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.05,15.9l2.95-1.7v-.37l-2.7,1.56c-.08,.17-.16,.35-.25,.52Z",
						fill: "#f48e1e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "20.92 21.37 20.27 21.74 20.92 21.74 21.57 21.37 20.92 21.37",
						fill: "#f48e1e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.83,21.37h-.26l-.65,.37h.65l.68-.39c-.14,0-.28,.02-.42,.02Z",
						fill: "#f58f1e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.7,16.47l3.3-1.91v-.37l-2.95,1.7c-.11,.2-.23,.39-.35,.58Z",
						fill: "#f58f1e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M30.27,17.1l3.73-2.15v-.37l-3.3,1.91c-.13,.21-.28,.42-.43,.62Z",
						fill: "#f5901e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.25,21.35l-.68,.39h.65l.76-.44c-.24,.03-.48,.03-.73,.04Z",
						fill: "#f5901e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.71,17.8l4.29-2.48v-.37l-3.73,2.15c-.18,.24-.37,.47-.56,.7Z",
						fill: "#f5911e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.98,21.3l-.76,.44h.65l.99-.57c-.29,.06-.58,.1-.88,.13Z",
						fill: "#f5911e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M23.86,21.17l-.99,.57h.65l1.52-.88c-.38,.12-.77,.22-1.17,.3Z",
						fill: "#f5921e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.84,18.67l5.16-2.98v-.37l-4.29,2.48c-.27,.31-.56,.6-.87,.88Z",
						fill: "#f5921e"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.04,20.87l-1.52,.88h.65l9.83-5.68v-.37l-5.16,2.98c-1.09,.98-2.38,1.74-3.8,2.2Z",
						fill: "#f6931e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "24.82 21.74 34 16.44 34 16.07 24.17 21.74 24.82 21.74",
						fill: "#f6941e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "25.47 21.74 34 16.82 34 16.44 24.82 21.74 25.47 21.74",
						fill: "#f6951e"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "26.11 21.74 34 17.19 34 16.82 25.47 21.74 26.11 21.74",
						fill: "#f6961f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "26.76 21.74 34 17.57 34 17.19 26.11 21.74 26.76 21.74",
						fill: "#f7971f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "27.41 21.74 34 17.94 34 17.57 26.76 21.74 27.41 21.74",
						fill: "#f7981f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "28.06 21.74 34 18.32 34 17.94 27.41 21.74 28.06 21.74",
						fill: "#f7991f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "28.71 21.74 34 18.69 34 18.32 28.06 21.74 28.71 21.74",
						fill: "#f79a1f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "29.36 21.74 34 19.07 34 18.69 28.71 21.74 29.36 21.74",
						fill: "#f89b1f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "30.01 21.74 34 19.44 34 19.07 29.36 21.74 30.01 21.74",
						fill: "#f89c1f"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "30.66 21.74 34 19.82 34 19.44 30.01 21.74 30.66 21.74",
						fill: "#f89d20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "31.31 21.74 34 20.19 34 19.82 30.66 21.74 31.31 21.74",
						fill: "#f89e20"
					},
					children: [
					]
				},
				{
					name: "polygon",
					type: "element",
					value: "",
					attributes: {
						points: "31.96 21.74 34 20.57 34 20.19 31.31 21.74 31.96 21.74",
						fill: "#f99f20"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M32.88,21.74c.62,0,1.12-.5,1.12-1.12v-.06l-2.04,1.18h.92Z",
						fill: "#f9a020"
					},
					children: [
					]
				}
			]
		}
	]
},
	discover: discover,
	"generic-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 32 20",
		style: "enable-background:new 0 0 32 20;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				stroke: "#FFFFFF",
				d: "M1,0.5h30c0.3,0,0.5,0.2,0.5,0.5v18c0,0.3-0.2,0.5-0.5,0.5H1c-0.3,0-0.5-0.2-0.5-0.5V1C0.5,0.7,0.7,0.5,1,0.5z"
			},
			children: [
			]
		},
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "4",
				y: "4",
				fill: "#FFFFFF",
				width: "24",
				height: "2"
			},
			children: [
			]
		},
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "23",
				y: "14",
				fill: "#FFFFFF",
				width: "2",
				height: "2"
			},
			children: [
			]
		},
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "26",
				y: "14",
				fill: "#FFFFFF",
				width: "2",
				height: "2"
			},
			children: [
			]
		}
	]
},
	generic: generic,
	jcb: jcb,
	mastercard: mastercard,
	"placeholder-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 20"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				stroke: "#333333",
				d: "M1,0.5h30c0.3,0,0.5,0.2,0.5,0.5v18c0,0.3-0.2,0.5-0.5,0.5H1c-0.3,0-0.5-0.2-0.5-0.5V1C0.5,0.7,0.7,0.5,1,0.5z"
			},
			children: [
			]
		},
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "4",
				y: "4",
				fill: "#333333",
				width: "24",
				height: "2"
			},
			children: [
			]
		},
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "23",
				y: "14",
				fill: "#333333",
				width: "2",
				height: "2"
			},
			children: [
			]
		},
		{
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "26",
				y: "14",
				fill: "#333333",
				width: "2",
				height: "2"
			},
			children: [
			]
		}
	]
},
	placeholder: placeholder,
	"securityCode-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 96 71.4",
		style: "enable-background:new 0 0 96 71.4;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "style",
			type: "element",
			value: "",
			attributes: {
				type: "text/css"
			},
			children: [
			]
		},
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M81.7,71.1H2.5c-1.2,0-2-0.8-2-2V21c0-1.2,0.8-2,2-2h79.4c1.2,0,2,0.8,2,2l-0.1,48.1\n\t\tC83.7,70.3,82.9,71.1,81.7,71.1z M81.8,21H2.5v48.1h79.3L81.8,21z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M1.4,25.4h82v2h-82V25.4z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M1.4,34.3h82v2h-82V34.3z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M48.1,42.6h12.5v2H48.1V42.6z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						"fill-rule": "evenodd",
						"clip-rule": "evenodd",
						d: "M90.9,31.7c6.3-8.4,4.3-20.6-4.2-26.8S66.1,0.8,59.9,9.3c-5.8,7.9-4.6,18.9,2.6,25.4l-0.1,3.6l3.4-1.2\n\t\tC74.2,41.9,85,39.8,90.9,31.7z"
					},
					children: [
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M75.3,40.6c-3.2,0-6.5-0.8-9.4-2.4l-4.3,1.5l0.1-4.6c-7.4-6.9-8.4-18.2-2.5-26.4c6.5-9,19.1-11.1,28.1-4.6\n\t\tc4.4,3.1,7.3,7.8,8,13.2c0.8,5.3-0.5,10.6-3.6,14.9C87.7,37.7,81.5,40.6,75.3,40.6z M65.9,36.1l0.4,0.2c8,4.5,18.2,2.3,23.7-5.2\n\t\tc2.8-3.8,4-8.6,3.2-13.4c-0.8-4.9-3.3-9.1-7.3-12c-8-5.8-19.4-3.9-25.4,4.2c-5.5,7.6-4.4,18,2.6,24.1l0.3,0.3L63.4,37L65.9,36.1z"
					},
					children: [
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
						"enable-background": "new"
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M67.4,19.4h-1.9v-1.3c1.2,0,2.1-0.6,2.3-1.7h1.5v8.1h-1.9V19.4z"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M71.9,22.3c0.6-0.6,1.3-1.1,2-1.6c1-0.7,1.5-1,1.5-1.8c0-0.7-0.4-1.1-1.1-1.1c-0.4,0-0.7,0.1-0.9,0.4\n\t\t\tC73.1,18.6,73,19,73,19.5h-1.8c0-0.8,0.2-1.4,0.5-1.9c0.5-0.7,1.3-1.2,2.6-1.2c1.9,0,2.9,1.2,2.9,2.6s-1,2.2-2.2,2.8\n\t\t\tc-0.8,0.5-1.2,0.7-1.5,1.2h3.6v1.6h-6.2C71,23.6,71.3,22.9,71.9,22.3z"
							},
							children: [
							]
						}
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M79.4,23.9c-0.6-0.5-1-1.2-1-2.1h1.8c0.1,0.8,0.5,1.3,1.5,1.3c0.8,0,1.3-0.4,1.3-1.2c0-0.7-0.5-1.1-1.4-1.1\n\t\th-0.4v-1.3h0.4c0.8,0,1.2-0.4,1.2-1c0-0.5-0.4-1-1.1-1c-0.9,0-1.2,0.6-1.3,1.2h-1.8c0-1.4,1.2-2.6,3-2.6c1.7,0,2.8,0.8,2.8,2.2\n\t\tc0,0.8-0.5,1.3-1.3,1.6c1,0.3,1.6,0.9,1.6,2c0,1.7-1.5,2.7-3,2.7C80.7,24.7,80,24.3,79.4,23.9z"
					},
					children: [
					]
				}
			]
		}
	]
},
	securityCode: securityCode,
	"securityCodeAmex-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 96.9 71.9",
		style: "enable-background:new 0 0 96.9 71.9;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M82.6,71.5H2.4c-1.2,0-2-0.8-2-2V21.1c0-1.2,0.8-2,2-2h80.2c1.2,0,2,0.8,2,2v48.5\n\t\t\tC84.6,70.7,83.8,71.5,82.6,71.5z M2.4,21.1v48.5h80.2V21.1H2.4z"
							},
							children: [
							]
						},
						{
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "63.6",
								y: "44.8",
								fill: "#FFFFFF",
								width: "14.8",
								height: "2"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M20.2,43.8h-7.9c-1.7,0-3-1.3-3-3v-4.9c0-1.7,1.3-3,3-3h7.9c1.7,0,3,1.3,3,3v4.9\n\t\t\tC23.2,42.5,21.9,43.8,20.2,43.8z M12.3,34.9c-0.6,0-1,0.4-1,1v4.9c0,0.6,0.4,1,1,1h7.9c0.6,0,1-0.4,1-1v-4.9c0-0.6-0.4-1-1-1H12.3\n\t\t\tz"
							},
							children: [
							]
						},
						{
							name: "g",
							type: "element",
							value: "",
							attributes: {
							},
							children: [
								{
									name: "path",
									type: "element",
									value: "",
									attributes: {
										"fill-rile": "evenodd",
										"clip-rule": "evenodd",
										d: "M93.7,28.8c4.5-9.7,0.4-21.2-9.3-25.6s-21.2-0.4-25.6,9.3c-4.3,9-0.8,19.6,7.4,24.6l0.6,3.7l3.3-1.9\n\t\t\t\tC79.2,42,89.4,37.8,93.7,28.8z"
									},
									children: [
									]
								},
								{
									name: "path",
									type: "element",
									value: "",
									attributes: {
										fill: "#FFFFFF",
										d: "M66,42.3l-0.7-4.7c-8.6-5.5-11.8-16.4-7.4-25.6c2.3-4.9,6.3-8.6,11.4-10.5c5-1.8,10.6-1.6,15.5,0.7\n\t\t\t\tc10.1,4.7,14.4,16.8,9.8,27l0,0C90.2,38.5,79.7,43,70.1,40L66,42.3z M76.2,2.3c-2.1,0-4.3,0.4-6.2,1.1c-4.6,1.7-8.2,5-10.3,9.4\n\t\t\t\tc-4,8.4-1,18.5,7,23.4l0.4,0.2l0.4,2.7l2.4-1.4l0.4,0.1c8.8,3.1,18.4-1.1,22.5-9.6C97,19,93,8.1,83.9,3.8\n\t\t\t\tC81.5,2.9,78.8,2.3,76.2,2.3z"
									},
									children: [
									]
								}
							]
						}
					]
				},
				{
					name: "g",
					type: "element",
					value: "",
					attributes: {
						"enable-background": "new"
					},
					children: [
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M64.2,19.5h-1.9v-1.3c1.2,0,2.1-0.6,2.3-1.7h1.5v8.2h-1.9V19.5z"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M68.8,22.4c0.6-0.6,1.3-1.1,2-1.6c1-0.7,1.5-1,1.5-1.8c0-0.7-0.4-1.1-1.1-1.1c-0.4,0-0.7,0.1-0.9,0.4\n\t\t\tc-0.3,0.3-0.4,0.7-0.4,1.2h-1.8c0-0.8,0.2-1.4,0.5-1.9c0.5-0.7,1.3-1.2,2.7-1.2c1.9,0,3,1.2,3,2.6s-1,2.2-2.2,2.9\n\t\t\tc-0.8,0.5-1.2,0.7-1.5,1.2l0,0h3.7v1.6H68C68,23.7,68.2,23,68.8,22.4z"
							},
							children: [
							]
						},
						{
							name: "path",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFFFFF",
								d: "M86.8,22.9H83v-1.7l3.8-4.7h1.9v4.9h1.2v1.4h-1.2v1.8h-1.9V22.9z M85.4,21.5h1.4v-1.9c0-0.5,0-0.9,0.1-1.3\n\t\t\tl0,0c-0.2,0.3-0.5,0.7-0.8,1.1l-0.8,1c-0.4,0.4-0.7,0.8-0.9,1.1l0,0C84.6,21.5,85,21.5,85.4,21.5z"
							},
							children: [
							]
						}
					]
				},
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#FFFFFF",
						d: "M76.3,24.1c-0.6-0.5-1-1.2-1-2.1h1.8c0.1,0.8,0.5,1.3,1.5,1.3c0.8,0,1.3-0.4,1.3-1.2c0-0.7-0.5-1.1-1.4-1.1\n\t\th-0.4v-1.3h0.4c0.8,0,1.2-0.4,1.2-1c0-0.5-0.4-1-1.1-1c-0.9,0-1.2,0.6-1.3,1.2h-1.8c0-1.4,1.2-2.6,3.1-2.6c1.7,0,2.9,0.8,2.9,2.2\n\t\tc0,0.8-0.5,1.3-1.3,1.6l0,0c1,0.3,1.6,0.9,1.6,2c0,1.7-1.5,2.8-3.1,2.8C77.7,24.9,76.9,24.6,76.3,24.1z"
					},
					children: [
					]
				}
			]
		}
	]
},
	securityCodeAmex: securityCodeAmex,
	"visa-inverted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 34 10.98"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.91,.19l-4.45,10.62h-2.9L3.36,2.34c-.13-.52-.25-.71-.65-.93-.66-.36-1.75-.69-2.71-.9L.07,.19H4.74c.6,0,1.13,.4,1.27,1.08l1.16,6.15L10.02,.19h2.89Zm11.38,7.15c.01-2.8-3.88-2.96-3.85-4.21,0-.38,.37-.79,1.17-.89,.39-.05,1.48-.09,2.71,.48l.48-2.25c-.66-.24-1.51-.47-2.57-.47-2.72,0-4.63,1.44-4.64,3.51-.02,1.53,1.36,2.38,2.4,2.89,1.07,.52,1.43,.85,1.43,1.32,0,.71-.85,1.03-1.65,1.04-1.38,.02-2.18-.37-2.82-.67l-.5,2.33c.64,.29,1.83,.55,3.06,.56,2.89,0,4.77-1.43,4.78-3.63m7.17,3.47h2.54L31.78,.19h-2.35c-.53,0-.97,.31-1.17,.78l-4.12,9.84h2.88l.57-1.59h3.52l.33,1.59Zm-3.07-3.76l1.45-3.99,.83,3.99h-2.28ZM16.83,.19l-2.27,10.62h-2.75L14.09,.19h2.75Z",
				fill: "#fff"
			},
			children: [
			]
		}
	]
},
	visa: visa
};

export { amex, CardData as default, dinersClub, discover, generic, jcb, mastercard, placeholder, securityCode, securityCodeAmex, visa };
